import * as e from "react";
import { useState as E, useRef as X, useCallback as le, useEffect as Z, Fragment as nn, useMemo as ge, useLayoutEffect as At, Component as It, createContext as an, useContext as on, createRef as ln } from "react";
import { createPortal as sn } from "react-dom";
const Lm = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, rt = "poc_portal_token", We = "poc_portal_refresh", tt = "auth:session-expired", Dt = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let Rt = Dt + "/chat-api/api/auth";
function jm(n) {
  n.authBase && (Rt = n.authBase);
}
function ct(n) {
  try {
    const t = n.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(t))));
  } catch {
    return {};
  }
}
function rn(n, t = 30) {
  const a = ct(n).exp;
  return !a || a * 1e3 < Date.now() + t * 1e3;
}
function Tt(n = 30) {
  const t = localStorage.getItem(We);
  if (!t) return !0;
  const a = ct(t).exp;
  return !!a && a * 1e3 < Date.now() + n * 1e3;
}
function cn() {
  return localStorage.getItem(rt);
}
function un(n, t) {
  localStorage.setItem(rt, n), t && localStorage.setItem(We, t);
}
function mn() {
  localStorage.removeItem(rt), localStorage.removeItem(We), zt();
}
function Te() {
  mn(), window.dispatchEvent(new Event(tt));
}
function Fm(n) {
  return window.addEventListener(tt, n), () => window.removeEventListener(tt, n);
}
let ze = null;
const dn = 2147483647;
function _n() {
  if (zt(), Tt()) {
    Te();
    return;
  }
  const n = localStorage.getItem(We), t = n ? ct(n).exp : void 0;
  if (!t) return;
  const a = Math.min(Math.max(t * 1e3 - Date.now() - 30 * 1e3, 0), dn);
  ze = setTimeout(() => {
    ze = null, _n();
  }, a);
}
function zt() {
  ze !== null && (clearTimeout(ze), ze = null);
}
let Ue = null;
function Pt() {
  return Ue || (Ue = pn()), Ue;
}
async function pn() {
  try {
    return await fn();
  } finally {
    Ue = null;
  }
}
async function fn() {
  const n = localStorage.getItem(We);
  if (!n)
    return Te(), null;
  let t;
  try {
    t = await fetch(Rt + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: n })
    });
  } catch {
    return null;
  }
  if (!t.ok)
    return t.status < 500 && Te(), null;
  const a = await t.json().catch(() => ({}));
  return a.access_token ? (un(a.access_token, a.refresh_token), a.access_token) : (Te(), null);
}
async function bn() {
  if (Tt())
    return Te(), null;
  const n = cn();
  return n && !rn(n) ? n : Pt();
}
async function qe(n, t = {}) {
  const a = (s) => {
    var r;
    return {
      ...t,
      headers: { ...(r = t.headers) != null ? r : {}, ...s ? { Authorization: "Bearer " + s } : {} }
    };
  }, o = await bn();
  let l = await fetch(n, a(o));
  if (l.status === 401 && o) {
    const s = await Pt();
    s && (l = await fetch(n, a(s)));
  }
  return l;
}
let Le = Dt + "/chat-api/api/comments";
function Mm(n) {
  n.base && (Le = n.base);
}
function hn(n) {
  return n.parentId !== void 0 && n.parentId !== null;
}
async function Ge(n) {
  var a;
  const t = await n.json().catch(() => ({}));
  if (!n.ok) throw new Error((a = t.error) != null ? a : `요청 실패 (${n.status})`);
  return t;
}
async function pt(n, t, a, o, l) {
  const s = new URLSearchParams({ targetType: n, targetId: t, page: String(a), size: String(o) }), r = await qe(`${Le}?${s}`, { cache: "no-store", signal: l });
  return Ge(r);
}
async function gn(n, t, a, o) {
  const l = await qe(Le, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: n, targetId: t, content: a, parentId: o })
  });
  return Ge(l);
}
async function yn(n, t) {
  const a = await qe(`${Le}/${n}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: t })
  });
  return Ge(a);
}
async function En(n) {
  const t = await qe(`${Le}/${n}`, { method: "DELETE" });
  return (await Ge(t)).status;
}
async function vn(n, t, a) {
  if (t.length === 0) return {};
  const o = new URLSearchParams({ targetType: n, targetIds: t.join(",") }), l = await qe(`${Le}/counts?${o}`, { cache: "no-store", signal: a });
  return (await Ge(l)).counts;
}
const ft = 50;
function nt(n) {
  return n.parentId === void 0 || n.parentId === null;
}
function kn(n, t) {
  if (nt(t)) return [...n, t];
  const a = t.parentId;
  let o = -1;
  for (let l = 0; l < n.length; l += 1)
    (n[l].id === a || n[l].parentId === a) && (o = l);
  return o < 0 ? [...n, t] : [...n.slice(0, o + 1), t, ...n.slice(o + 1)];
}
function je(n, t) {
  return n instanceof Error && n.message ? n.message : t;
}
function Nn(n, t) {
  const [a, o] = E([]), [l, s] = E(!0), [r, c] = E(!0), [i, u] = E(null), [m, d] = E(0), [p, f] = E(0), b = n + " " + t, _ = X(b);
  _.current = b;
  const [k, $] = E(0), S = le(() => $((C) => C + 1), []);
  Z(() => {
    const C = new AbortController(), L = b;
    return o([]), f(0), d(0), u(null), s(!0), c(!0), pt(n, t, 0, ft, C.signal).then((F) => {
      _.current === L && (o(F.items), d(F.total));
    }).catch((F) => {
      C.signal.aborted || _.current !== L || u(je(F, "댓글을 불러오지 못했어요."));
    }).finally(() => {
      _.current === L && (s(!1), c(!1));
    }), () => C.abort();
  }, [n, t, b, k]);
  const N = a.filter(nt).length < m, y = le(() => {
    if (l || !N) return;
    const C = p + 1, L = _.current;
    s(!0), pt(n, t, C, ft).then((F) => {
      _.current === L && (o((R) => [...R, ...F.items]), d(F.total), f(C));
    }).catch((F) => {
      _.current === L && u(je(F, "댓글을 더 불러오지 못했어요."));
    }).finally(() => {
      _.current === L && s(!1);
    });
  }, [l, N, p, n, t]), v = le(async (C, L) => {
    const F = C.trim();
    if (!F) return !1;
    const R = -Date.now(), D = {
      id: R,
      targetType: n,
      targetId: t,
      parentId: L != null ? L : null,
      authorName: "나",
      content: F,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, B = _.current;
    o((T) => kn(T, D)), u(null);
    try {
      const T = await gn(n, t, F, L);
      return _.current !== B || (o((q) => q.map((A) => A.id === R ? T : A)), L === void 0 && d((q) => q + 1)), !0;
    } catch (T) {
      return _.current !== B || (o((q) => q.filter((A) => A.id !== R)), u(je(T, "댓글을 등록하지 못했어요."))), !1;
    }
  }, [n, t]), j = le(async (C, L) => {
    const F = L.trim();
    if (!F) return !1;
    const R = _.current;
    try {
      const D = await yn(C, F);
      return _.current !== R || o((B) => B.map((T) => T.id === C ? D : T)), !0;
    } catch (D) {
      return _.current === R && u(je(D, "댓글을 수정하지 못했어요.")), !1;
    }
  }, []), I = le(async (C) => {
    const L = _.current;
    try {
      const F = await En(C);
      return _.current !== L ? !0 : F === "soft-deleted" ? (o((R) => R.map((D) => D.id === C ? { ...D, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : D)), !0) : (o((R) => {
        const D = R.find((A) => A.id === C), B = R.filter((A) => A.id !== C);
        if (!D) return B;
        if (nt(D))
          return d((A) => Math.max(0, A - 1)), B;
        const T = D.parentId, q = B.find((A) => A.id === T);
        return q && q.deleted && !B.some((A) => A.parentId === T) ? (d((A) => Math.max(0, A - 1)), B.filter((A) => A.id !== T)) : B;
      }), !0);
    } catch (F) {
      return _.current === L && u(je(F, "댓글을 삭제하지 못했어요.")), !1;
    }
  }, []);
  return {
    items: a,
    loading: l,
    initialLoading: r,
    error: i,
    count: a.filter((C) => !C.deleted).length,
    hasMore: N,
    loadMore: y,
    reload: S,
    add: v,
    edit: j,
    remove: I
  };
}
const wn = "_thread_1layy_9", $n = "_head_1layy_28", xn = "_headTitle_1layy_37", Cn = "_headCount_1layy_43", Bn = "_list_1layy_54", Sn = "_row_1layy_61", Ln = "_isReply_1layy_73", jn = "_pending_1layy_80", Fn = "_avatar_1layy_84", Mn = "_avatarGhost_1layy_98", An = "_body_1layy_103", In = "_meta_1layy_108", Dn = "_author_1layy_116", Rn = "_dept_1layy_122", Tn = "_time_1layy_130", zn = "_text_1layy_135", Pn = "_textDeleted_1layy_143", On = "_acts_1layy_148", Xn = "_act_1layy_148", Wn = "_actDanger_1layy_169", qn = "_empty_1layy_175", Gn = "_error_1layy_182", Kn = "_skeleton_1layy_196", Hn = "_more_1layy_219", Un = "_foot_1layy_245", Yn = "_composer_1layy_252", Vn = "_composerInput_1layy_261", Jn = "_composerActions_1layy_284", Zn = "_btn_1layy_291", Qn = "_btnPrimary_1layy_301", ea = "_btnGhost_1layy_310", w = {
  thread: wn,
  head: $n,
  headTitle: xn,
  headCount: Cn,
  list: Bn,
  row: Sn,
  isReply: Ln,
  pending: jn,
  avatar: Fn,
  avatarGhost: Mn,
  body: An,
  meta: In,
  author: Dn,
  dept: Rn,
  time: Tn,
  text: zn,
  textDeleted: Pn,
  acts: On,
  act: Xn,
  actDanger: Wn,
  empty: qn,
  error: Gn,
  skeleton: Kn,
  more: Hn,
  foot: Un,
  composer: Yn,
  composerInput: Vn,
  composerActions: Jn,
  btn: Zn,
  btnPrimary: Qn,
  btnGhost: ea
}, bt = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function ta(n) {
  let t = 0;
  for (let a = 0; a < n.length; a += 1) t = (t * 31 + n.charCodeAt(a)) % 997;
  return bt[t % bt.length];
}
function na(n) {
  const t = n.trim();
  return t ? t[0].toUpperCase() : "?";
}
const ht = 6e4, gt = 36e5, yt = 864e5, aa = 6048e5;
function oa(n) {
  const t = new Date(n).getTime();
  if (Number.isNaN(t)) return "";
  const a = Date.now() - t;
  if (a < ht) return "방금";
  if (a < gt) return `${Math.floor(a / ht)}분 전`;
  if (a < yt) return `${Math.floor(a / gt)}시간 전`;
  if (a < aa) return `${Math.floor(a / yt)}일 전`;
  const o = new Date(t), l = (s) => s < 10 ? `0${s}` : String(s);
  return `${o.getFullYear()}.${l(o.getMonth() + 1)}.${l(o.getDate())}`;
}
function at({
  placeholder: n,
  submitLabel: t,
  autoFocus: a,
  initialValue: o,
  onSubmit: l,
  onCancel: s
}) {
  const [r, c] = E(o != null ? o : ""), [i, u] = E(!1), m = X(null);
  Z(() => {
    a && m.current && m.current.focus();
  }, [a]);
  const d = async () => {
    const p = r.trim();
    if (!p || i) return;
    u(!0);
    const f = await l(p);
    u(!1), f && c("");
  };
  return /* @__PURE__ */ e.createElement("div", { className: w.composer }, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: m,
      className: w.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: n,
      value: r,
      disabled: i,
      onChange: (p) => c(p.target.value),
      onKeyDown: (p) => {
        const f = p.nativeEvent.isComposing;
        p.key === "Enter" && !p.shiftKey && !f && (p.preventDefault(), d()), p.key === "Escape" && s && (p.nativeEvent.stopPropagation(), s());
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: w.composerActions }, s && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${w.btn} ${w.btnGhost}`,
      onClick: s,
      disabled: i
    },
    "취소"
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${w.btn} ${w.btnPrimary}`,
      onClick: () => void d(),
      disabled: i || !r.trim()
    },
    i ? "보내는 중…" : t
  )));
}
function la({
  item: n,
  replying: t,
  editing: a,
  onReply: o,
  onEdit: l,
  onSubmitReply: s,
  onSubmitEdit: r,
  onDelete: c,
  onCancel: i
}) {
  var p, f;
  const u = hn(n), m = u ? ` ${w.isReply}` : "";
  if (n.deleted)
    return /* @__PURE__ */ e.createElement("div", { className: `${w.row}${m}` }, /* @__PURE__ */ e.createElement("span", { className: `${w.avatar} ${w.avatarGhost}` }, "·"), /* @__PURE__ */ e.createElement("div", { className: w.body }, /* @__PURE__ */ e.createElement("div", { className: `${w.text} ${w.textDeleted}` }, "삭제된 댓글입니다")));
  const d = (p = n.authorName) != null ? p : "anonymous";
  return /* @__PURE__ */ e.createElement("div", { className: `${w.row}${m}${n.pending ? ` ${w.pending}` : ""}` }, /* @__PURE__ */ e.createElement("span", { className: w.avatar, style: { background: ta(d) } }, na(d)), /* @__PURE__ */ e.createElement("div", { className: w.body }, /* @__PURE__ */ e.createElement("div", { className: w.meta }, /* @__PURE__ */ e.createElement("span", { className: w.author }, d), n.dept && /* @__PURE__ */ e.createElement("span", { className: w.dept }, n.dept), /* @__PURE__ */ e.createElement("span", { className: w.time }, oa(n.createdAt)), n.updatedAt && /* @__PURE__ */ e.createElement("span", { className: w.time }, "(수정됨)")), a ? /* @__PURE__ */ e.createElement(
    at,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (f = n.content) != null ? f : "",
      onSubmit: r,
      onCancel: i
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: w.text }, n.content), !a && !n.pending && /* @__PURE__ */ e.createElement("div", { className: w.acts }, !u && /* @__PURE__ */ e.createElement("button", { type: "button", className: w.act, onClick: o }, "답글"), n.mine && /* @__PURE__ */ e.createElement("button", { type: "button", className: w.act, onClick: l }, "수정"), n.mine && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${w.act} ${w.actDanger}`,
      onClick: c
    },
    "삭제"
  )), t && /* @__PURE__ */ e.createElement(
    at,
    {
      placeholder: `${d} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: s,
      onCancel: i
    }
  )));
}
function Am({
  targetType: n,
  targetId: t,
  onCountChange: a,
  autoFocus: o,
  showHeader: l = !0,
  className: s,
  style: r
}) {
  const { items: c, initialLoading: i, loading: u, error: m, count: d, hasMore: p, loadMore: f, reload: b, add: _, edit: k, remove: $ } = Nn(n, t), [S, g] = E(null), [N, y] = E(null);
  Z(() => {
    g(null), y(null);
  }, [n, t]);
  const v = X(a);
  return v.current = a, Z(() => {
    !i && v.current && v.current(d);
  }, [d, i]), /* @__PURE__ */ e.createElement("div", { className: s ? `${w.thread} ${s}` : w.thread, style: r }, l && /* @__PURE__ */ e.createElement("div", { className: w.head }, /* @__PURE__ */ e.createElement("span", { className: w.headTitle }, "댓글"), /* @__PURE__ */ e.createElement("span", { className: w.headCount }, d)), /* @__PURE__ */ e.createElement("div", { className: w.list }, i && /* @__PURE__ */ e.createElement("div", { className: w.skeleton }, /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null)), m && /* @__PURE__ */ e.createElement("div", { className: w.error }, /* @__PURE__ */ e.createElement("span", null, m), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${w.btn} ${w.btnGhost}`,
      onClick: b
    },
    "다시 시도"
  )), !i && !m && c.length === 0 && /* @__PURE__ */ e.createElement("div", { className: w.empty }, "첫 댓글을 남겨 보세요."), c.map((j) => /* @__PURE__ */ e.createElement(
    la,
    {
      key: j.id,
      item: j,
      replying: S === j.id,
      editing: N === j.id,
      onReply: () => {
        y(null), g(j.id);
      },
      onEdit: () => {
        g(null), y(j.id);
      },
      onCancel: () => {
        g(null), y(null);
      },
      onSubmitReply: async (I) => {
        const C = await _(I, j.id);
        return C && g(null), C;
      },
      onSubmitEdit: async (I) => {
        const C = await k(j.id, I);
        return C && y(null), C;
      },
      onDelete: () => {
        $(j.id);
      }
    }
  )), p && /* @__PURE__ */ e.createElement("button", { type: "button", className: w.more, onClick: f, disabled: u }, u ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ e.createElement("div", { className: w.foot }, /* @__PURE__ */ e.createElement(
    at,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (j) => _(j)
    }
  )));
}
function Im(n, t) {
  const [a, o] = E({}), [l, s] = E(!1), [r, c] = E(0), i = t.join(",");
  return Z(() => {
    const u = i ? i.split(",") : [];
    if (u.length === 0) {
      o({});
      return;
    }
    const m = new AbortController();
    return s(!0), vn(n, u, m.signal).then((d) => {
      m.signal.aborted || o(d);
    }).catch(() => {
      m.signal.aborted || o({});
    }).finally(() => {
      m.signal.aborted || s(!1);
    }), () => m.abort();
  }, [n, i, r]), {
    counts: a,
    loading: l,
    reload: () => c((u) => u + 1)
  };
}
const sa = "_card_epi3f_1", ra = "_header_epi3f_8", ca = "_headerNoDivider_epi3f_13", ia = "_body_epi3f_17", ua = "_paddingSm_epi3f_22", ma = "_paddingMd_epi3f_26", da = "_paddingLg_epi3f_30", re = {
  card: sa,
  header: ra,
  headerNoDivider: ca,
  body: ia,
  paddingSm: ua,
  paddingMd: ma,
  paddingLg: da
};
function Dm({
  children: n,
  header: t,
  padding: a = "md",
  radius: o,
  headerDivider: l = !0,
  headerBackground: s,
  headerPadding: r,
  headerBorderColor: c,
  className: i
}) {
  const u = typeof a == "number" ? "" : a === "sm" ? re.paddingSm : a === "lg" ? re.paddingLg : re.paddingMd, m = typeof a == "number" ? { padding: a } : void 0, d = i ? `${re.card} ${i}` : re.card, p = l ? re.header : `${re.header} ${re.headerNoDivider}`, f = {
    ...s !== void 0 ? { background: s } : {},
    ...r !== void 0 ? { padding: r } : {},
    ...c !== void 0 ? { borderBottomColor: c } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: d, style: o !== void 0 ? { borderRadius: o } : void 0 }, t && /* @__PURE__ */ e.createElement("div", { className: p, style: f }, t), /* @__PURE__ */ e.createElement("div", { className: `${re.body} ${u}`, style: m }, n));
}
const _a = "_horizontal_mkht7_1", pa = "_vertical_mkht7_8", Et = {
  horizontal: _a,
  vertical: pa
};
function Rm({ orientation: n = "horizontal", spacing: t = 0, color: a }) {
  const o = n === "vertical";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o ? Et.vertical : Et.horizontal,
      style: {
        ...o ? { marginLeft: t, marginRight: t } : { marginTop: t, marginBottom: t },
        ...a !== void 0 ? { backgroundColor: a } : {}
      },
      role: "separator",
      "aria-orientation": n
    }
  );
}
const fa = "_root_nvy8t_1", ba = "_icon_nvy8t_7", ha = "_iconBadge_nvy8t_15", ga = "_titleGroup_nvy8t_25", ya = "_title_nvy8t_25", Ea = "_subtitle_nvy8t_41", va = "_trailing_nvy8t_49", ka = "_closeButton_nvy8t_58", be = {
  root: fa,
  icon: ba,
  iconBadge: ha,
  titleGroup: ga,
  title: ya,
  subtitle: Ea,
  trailing: va,
  closeButton: ka
};
function Tm({
  icon: n,
  iconColor: t,
  iconBadge: a = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: l,
  iconBadgeSize: s,
  title: r,
  titleWeight: c,
  titleSize: i,
  subtitle: u,
  subtitleColor: m,
  subtitleSize: d,
  trailing: p,
  onClose: f
}) {
  const b = {
    ...c !== void 0 ? { fontWeight: c } : {},
    ...i !== void 0 ? { fontSize: i } : {}
  }, _ = {
    ...m !== void 0 ? { color: m } : {},
    ...d !== void 0 ? { fontSize: d } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: be.root }, n && a && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: be.iconBadge,
      style: {
        ...l ? { background: `linear-gradient(135deg, ${l[0]}, ${l[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...s !== void 0 ? { width: s, height: s } : {}
      }
    },
    n
  ), n && !a && /* @__PURE__ */ e.createElement("span", { className: be.icon, style: t !== void 0 ? { color: t } : void 0 }, n), /* @__PURE__ */ e.createElement("div", { className: be.titleGroup }, /* @__PURE__ */ e.createElement("span", { className: be.title, style: b }, r), u && /* @__PURE__ */ e.createElement("span", { className: be.subtitle, style: _ }, u)), p && /* @__PURE__ */ e.createElement("div", { className: be.trailing }, p), f && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: be.closeButton,
      onClick: f,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const Na = "_badge_19977_1", wa = {
  badge: Na
};
function zm({
  size: n = 32,
  gradient: t = ["#7C3AED", "#3B82F6"],
  icon: a
}) {
  const o = n * 0.55;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: wa.badge,
      style: {
        width: n,
        height: n,
        background: `linear-gradient(135deg, ${t[0]}, ${t[1]})`
      }
    },
    a != null ? a : /* @__PURE__ */ e.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const $a = "_wrapper_ccmq2_1", xa = "_image_ccmq2_8", Ca = "_fallback_ccmq2_16", Ba = "_statusDot_ccmq2_29", Ke = {
  wrapper: $a,
  image: xa,
  fallback: Ca,
  statusDot: Ba
}, Sa = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function La(n) {
  const t = n == null ? void 0 : n.trim();
  return t ? Array.from(t)[0].toUpperCase() : "";
}
const Je = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function ja(n) {
  const t = n == null ? void 0 : n.trim();
  if (!t) return Je[5];
  let a = 0;
  for (let o = 0; o < t.length; o += 1)
    a = a * 31 + t.charCodeAt(o) | 0;
  return Je[Math.abs(a) % Je.length];
}
function Ot({
  src: n,
  fallbackText: t,
  alt: a,
  size: o = 32,
  statusDot: l,
  color: s,
  ring: r = !1,
  ringColor: c = "#fff"
}) {
  var d;
  const [i, u] = E(), m = !!n && i !== n;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ke.wrapper,
      style: {
        width: o,
        height: o,
        ...r ? { boxShadow: `0 0 0 2px ${c}` } : {}
      }
    },
    m ? /* @__PURE__ */ e.createElement(
      "img",
      {
        className: Ke.image,
        src: n,
        alt: (d = a != null ? a : t) != null ? d : "",
        onError: () => u(n)
      }
    ) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: Ke.fallback,
        style: {
          backgroundColor: s != null ? s : ja(t),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      La(t)
    ),
    l && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: Ke.statusDot,
        style: {
          backgroundColor: Sa[l],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const Fa = "_stack_y8phg_1", Ma = "_item_y8phg_6", Aa = "_overflow_y8phg_18", He = {
  stack: Fa,
  item: Ma,
  overflow: Aa
};
function Pm({
  avatars: n,
  max: t = 4,
  size: a = 32
}) {
  const o = n.slice(0, t), l = n.length - o.length;
  return /* @__PURE__ */ e.createElement("span", { className: He.stack }, o.map((s, r) => /* @__PURE__ */ e.createElement("span", { key: r, className: He.item, style: { zIndex: o.length - r } }, /* @__PURE__ */ e.createElement(Ot, { src: s.src, alt: s.alt, fallbackText: s.fallbackText, size: a }))), l > 0 && /* @__PURE__ */ e.createElement("span", { className: He.item, style: { zIndex: 0 } }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: He.overflow,
      style: { width: a, height: a, fontSize: Math.max(10, a * 0.36) }
    },
    "+",
    l
  )));
}
const Ia = "_badge_1mjda_1", Da = "_pill_1mjda_15", Ra = "_dot_1mjda_19", Ta = "_dotPulse_1mjda_26", za = "_outline_1mjda_40", Pa = "_soft_1mjda_46", Fe = {
  badge: Ia,
  pill: Da,
  dot: Ra,
  dotPulse: Ta,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: za,
  soft: Pa
};
function Om({
  label: n,
  variant: t = "default",
  color: a,
  background: o,
  textColor: l,
  shape: s = "rounded",
  dot: r = !1,
  dotColor: c,
  dotPulse: i = !1,
  border: u = !1,
  borderColor: m = "currentColor"
}) {
  var b;
  const d = {};
  a && (t === "default" ? (d.backgroundColor = a, d.color = "#fff") : t === "outline" ? (d.borderColor = a, d.color = a) : (d.backgroundColor = `${a}1A`, d.color = a)), o !== void 0 && (d.backgroundColor = o), l !== void 0 && (d.color = l), u && (d.borderColor = m);
  const p = [
    Fe.badge,
    Fe[t],
    s === "pill" ? Fe.pill : ""
  ].filter(Boolean).join(" "), f = [Fe.dot, i ? Fe.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ e.createElement("span", { className: p, style: d }, r && /* @__PURE__ */ e.createElement("span", { className: f, style: { backgroundColor: c != null ? c : (b = l != null ? l : a) != null ? b : "currentColor" } }), n);
}
const Oa = "_row_1k2ap_1", Xa = "_reply_1k2ap_7", Wa = "_avatar_1k2ap_12", qa = "_avatarImage_1k2ap_25", Ga = "_avatarFallback_1k2ap_32", Ka = "_body_1k2ap_44", Ha = "_headerLine_1k2ap_49", Ua = "_author_1k2ap_56", Ya = "_meta_1k2ap_62", Va = "_text_1k2ap_67", Ja = "_actionsRow_1k2ap_74", Za = "_actionBtn_1k2ap_81", U = {
  row: Oa,
  reply: Xa,
  avatar: Wa,
  avatarImage: qa,
  avatarFallback: Ga,
  body: Ka,
  headerLine: Ha,
  author: Ua,
  meta: Ya,
  text: Va,
  actionsRow: Ja,
  actionBtn: Za
};
function Qa(n) {
  const t = n.trim();
  return t ? t[0].toUpperCase() : "";
}
function Xm({
  avatarSrc: n,
  author: t,
  meta: a,
  text: o,
  likeCount: l,
  replyCount: s,
  isReply: r = !1,
  onLikeClick: c,
  onReplyClick: i
}) {
  const [u, m] = E(!1), d = !!n && !u;
  return /* @__PURE__ */ e.createElement("div", { className: `${U.row} ${r ? U.reply : ""}` }, /* @__PURE__ */ e.createElement("span", { className: U.avatar }, d ? /* @__PURE__ */ e.createElement(
    "img",
    {
      className: U.avatarImage,
      src: n,
      alt: t,
      onError: () => m(!0)
    }
  ) : /* @__PURE__ */ e.createElement("span", { className: U.avatarFallback }, Qa(t))), /* @__PURE__ */ e.createElement("div", { className: U.body }, /* @__PURE__ */ e.createElement("div", { className: U.headerLine }, /* @__PURE__ */ e.createElement("span", { className: U.author }, t), a && /* @__PURE__ */ e.createElement("span", { className: U.meta }, a)), /* @__PURE__ */ e.createElement("div", { className: U.text }, o), /* @__PURE__ */ e.createElement("div", { className: U.actionsRow }, /* @__PURE__ */ e.createElement("button", { type: "button", className: U.actionBtn, onClick: c }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof l == "number" && /* @__PURE__ */ e.createElement("span", null, l)), /* @__PURE__ */ e.createElement("button", { type: "button", className: U.actionBtn, onClick: i }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof s == "number" && /* @__PURE__ */ e.createElement("span", null, s)))));
}
const eo = "_wrapper_79n51_1", to = {
  wrapper: eo
}, no = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, ao = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function oo({ ext: n, size: t = 32 }) {
  var r;
  const a = n.trim().toLowerCase().replace(/^\./, ""), { label: o, color: l, bg: s } = (r = no[a]) != null ? r : ao;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: to.wrapper,
      style: {
        width: t,
        height: t,
        backgroundColor: s,
        color: l,
        fontSize: Math.max(8, t * 0.26)
      }
    },
    o
  );
}
const lo = "_chip_1jhj8_1", so = "_clickable_1jhj8_12", ro = "_icon_1jhj8_21", co = "_info_1jhj8_26", io = "_name_1jhj8_33", uo = "_size_1jhj8_42", mo = "_chipError_1jhj8_48", _o = "_chipDone_1jhj8_53", po = "_status_1jhj8_57", fo = "_statusError_1jhj8_66", bo = "_statusDone_1jhj8_67", ho = "_statusIcon_1jhj8_69", go = "_statusLabel_1jhj8_71", yo = "_progressTrack_1jhj8_78", Eo = "_progressFill_1jhj8_88", vo = "_actionBtn_1jhj8_96", O = {
  chip: lo,
  clickable: so,
  icon: ro,
  info: co,
  name: io,
  size: uo,
  chipError: mo,
  chipDone: _o,
  status: po,
  statusError: fo,
  statusDone: bo,
  statusIcon: ho,
  statusLabel: go,
  progressTrack: yo,
  progressFill: Eo,
  actionBtn: vo
};
function Wm({
  name: n,
  ext: t,
  size: a,
  onRemove: o,
  downloadable: l = !1,
  onClick: s,
  status: r,
  statusText: c,
  percent: i
}) {
  const u = r === "error" ? O.chipError : r === "done" ? O.chipDone : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${O.chip} ${s ? O.clickable : ""} ${u}`,
      onClick: s,
      title: r === "error" ? c : void 0
    },
    t && /* @__PURE__ */ e.createElement("span", { className: O.icon }, /* @__PURE__ */ e.createElement(oo, { ext: t, size: 28 })),
    /* @__PURE__ */ e.createElement("span", { className: O.info }, /* @__PURE__ */ e.createElement("span", { className: O.name }, n), c ? /* @__PURE__ */ e.createElement("span", { className: `${O.status} ${r === "error" ? O.statusError : r === "done" ? O.statusDone : ""}` }, r === "error" && /* @__PURE__ */ e.createElement("svg", { className: O.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7v6M12 16.5v.01" })), r === "done" && /* @__PURE__ */ e.createElement("svg", { className: O.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ e.createElement("span", { className: O.statusLabel }, c)) : a ? /* @__PURE__ */ e.createElement("span", { className: O.size }, a) : null, r === "processing" && /* @__PURE__ */ e.createElement("span", { className: O.progressTrack }, /* @__PURE__ */ e.createElement("span", { className: O.progressFill, style: { width: `${Math.max(0, Math.min(100, i != null ? i : 0))}%` } }))),
    l ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: O.actionBtn,
        "aria-label": "download",
        onClick: (m) => m.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: O.actionBtn,
        "aria-label": "remove",
        onClick: (m) => {
          m.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const ko = "_list_1yxwc_1", No = "_row_1yxwc_6", wo = "_inline_1yxwc_15", $o = "_label_1yxwc_22", xo = "_value_1yxwc_29", Co = "_stacked_1yxwc_35", Bo = "_bold_1yxwc_51", Ne = {
  list: ko,
  row: No,
  inline: wo,
  label: $o,
  value: xo,
  stacked: Co,
  bold: Bo
};
function qm({
  rows: n,
  direction: t = "inline"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: `${Ne.list} ${Ne[t]}` }, n.map((a, o) => /* @__PURE__ */ e.createElement("div", { key: o, className: Ne.row }, /* @__PURE__ */ e.createElement("span", { className: Ne.label }, a.label), /* @__PURE__ */ e.createElement("span", { className: `${Ne.value} ${a.bold ? Ne.bold : ""}` }, a.value))));
}
const So = "_container_2r163_1", Lo = "_row_2r163_5", jo = "_clickable_2r163_12", Fo = "_leading_2r163_20", Mo = "_main_2r163_26", Ao = "_titleLine_2r163_34", Io = "_title_2r163_34", Do = "_tags_2r163_50", Ro = "_meta_2r163_57", To = "_actions_2r163_62", zo = "_expandable_2r163_69", Q = {
  container: So,
  row: Lo,
  clickable: jo,
  leading: Fo,
  main: Mo,
  titleLine: Ao,
  title: Io,
  tags: Do,
  meta: Ro,
  actions: To,
  expandable: zo
};
function Gm({
  leading: n,
  title: t,
  meta: a,
  tags: o,
  actions: l,
  expandableContent: s,
  expanded: r = !1,
  onClick: c
}) {
  return /* @__PURE__ */ e.createElement("div", { className: Q.container }, /* @__PURE__ */ e.createElement("div", { className: `${Q.row} ${c ? Q.clickable : ""}`, onClick: c }, n && /* @__PURE__ */ e.createElement("div", { className: Q.leading }, n), /* @__PURE__ */ e.createElement("div", { className: Q.main }, /* @__PURE__ */ e.createElement("div", { className: Q.titleLine }, /* @__PURE__ */ e.createElement("span", { className: Q.title }, t), o && /* @__PURE__ */ e.createElement("span", { className: Q.tags }, o)), a && /* @__PURE__ */ e.createElement("div", { className: Q.meta }, a)), l && /* @__PURE__ */ e.createElement("div", { className: Q.actions, onClick: (i) => i.stopPropagation() }, l)), r && s && /* @__PURE__ */ e.createElement("div", { className: Q.expandable }, s));
}
const Po = "_row_xzgny_1", Oo = "_info_xzgny_8", Xo = "_name_xzgny_16", Wo = "_subtitle_xzgny_25", qo = "_status_xzgny_33", Me = {
  row: Po,
  info: Oo,
  name: Xo,
  subtitle: Wo,
  status: qo
};
function Km({
  avatarSrc: n,
  name: t,
  subtitle: a,
  status: o,
  statusColor: l = "#64748B",
  statusBg: s = "#F1F5F9"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: Me.row }, /* @__PURE__ */ e.createElement(Ot, { src: n, fallbackText: t, size: 36 }), /* @__PURE__ */ e.createElement("div", { className: Me.info }, /* @__PURE__ */ e.createElement("span", { className: Me.name }, t), a && /* @__PURE__ */ e.createElement("span", { className: Me.subtitle }, a)), o && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Me.status,
      style: { color: l, backgroundColor: s }
    },
    o
  ));
}
const Go = "_row_qoxwr_1", Ko = "_clickable_qoxwr_9", Ho = "_rank_qoxwr_17", Uo = "_title_qoxwr_25", Yo = "_trailing_qoxwr_36", Ae = {
  row: Go,
  clickable: Ko,
  rank: Ho,
  title: Uo,
  trailing: Yo
}, Vo = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function Hm({
  rank: n,
  rankColor: t,
  title: a,
  trailingText: o,
  onClick: l
}) {
  var r;
  const s = (r = t != null ? t : Vo[n]) != null ? r : "#64748B";
  return /* @__PURE__ */ e.createElement("div", { className: `${Ae.row} ${l ? Ae.clickable : ""}`, onClick: l }, /* @__PURE__ */ e.createElement("span", { className: Ae.rank, style: { color: s } }, n), /* @__PURE__ */ e.createElement("span", { className: Ae.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: Ae.trailing }, o));
}
const Jo = "_badge_1qibj_1", Zo = "_sm_1qibj_11", Qo = "_md_1qibj_16", el = "_overdue_1qibj_21", tl = "_warning_1qibj_26", nl = "_progress_1qibj_31", al = "_success_1qibj_36", ol = "_info_1qibj_41", ll = "_neutral_1qibj_46", Ze = {
  badge: Jo,
  sm: Zo,
  md: Qo,
  overdue: el,
  warning: tl,
  progress: nl,
  success: al,
  info: ol,
  neutral: ll
};
function Um({
  label: n,
  tone: t = "neutral",
  size: a = "md",
  background: o,
  textColor: l
}) {
  const s = {};
  return o !== void 0 && (s.backgroundColor = o), l !== void 0 && (s.color = l), /* @__PURE__ */ e.createElement("span", { className: `${Ze.badge} ${Ze[t]} ${Ze[a]}`, style: s }, n);
}
const sl = "_wrapper_14p14_1", rl = "_avatar_14p14_11", cl = "_body_14p14_21", il = "_message_14p14_26", ul = "_dots_14p14_32", ml = "_dot_14p14_32", dl = "_action_14p14_70", _l = "_actionIcon_14p14_89", pl = "_gradientWrapper_14p14_95", fl = "_bareIcon_14p14_100", bl = "_ctaButton_14p14_109", G = {
  wrapper: sl,
  avatar: rl,
  body: cl,
  message: il,
  dots: ul,
  dot: ml,
  action: dl,
  actionIcon: _l,
  gradientWrapper: pl,
  bareIcon: fl,
  ctaButton: bl
};
function vt() {
  return /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function kt() {
  return /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function Ym({
  message: n,
  accentColor: t = "#7C3AED",
  buttonLabel: a,
  buttonIcon: o,
  onAction: l,
  phase: s = "complete",
  variant: r = "card",
  gradientColors: c = ["#EEF4FF", "#F3EEFF"]
}) {
  const i = r === "gradient-cta";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [G.wrapper, i ? G.gradientWrapper : ""].join(" "),
      style: i ? { borderColor: `${t}33`, background: `linear-gradient(135deg, ${c[0]}, ${c[1]})` } : { borderColor: `${t}33` }
    },
    i ? /* @__PURE__ */ e.createElement("span", { className: G.bareIcon, style: { color: t } }, /* @__PURE__ */ e.createElement(vt, null)) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: G.avatar,
        style: { backgroundColor: `${t}1A`, color: t }
      },
      /* @__PURE__ */ e.createElement(vt, null)
    ),
    /* @__PURE__ */ e.createElement("div", { className: G.body }, s === "loading" ? /* @__PURE__ */ e.createElement("span", { className: G.dots }, /* @__PURE__ */ e.createElement("span", { className: G.dot, style: { backgroundColor: t } }), /* @__PURE__ */ e.createElement("span", { className: G.dot, style: { backgroundColor: t } }), /* @__PURE__ */ e.createElement("span", { className: G.dot, style: { backgroundColor: t } })) : /* @__PURE__ */ e.createElement("span", { className: G.message, style: i ? { color: t } : void 0 }, n)),
    a && l && (i ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: G.ctaButton,
        style: { backgroundColor: t },
        onClick: l
      },
      /* @__PURE__ */ e.createElement("span", null, a),
      /* @__PURE__ */ e.createElement("span", { className: G.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(kt, null) : o)
    ) : /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: G.action,
        style: { color: t },
        onClick: l
      },
      /* @__PURE__ */ e.createElement("span", null, a),
      /* @__PURE__ */ e.createElement("span", { className: G.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(kt, null) : o)
    ))
  );
}
const hl = "_wrapper_68zkp_1", gl = "_bordered_68zkp_13", yl = "_compact_68zkp_17", El = "_icon_68zkp_23", vl = "_title_68zkp_31", kl = "_description_68zkp_38", Nl = "_action_68zkp_46", ye = {
  wrapper: hl,
  bordered: gl,
  compact: yl,
  icon: El,
  title: vl,
  description: kl,
  action: Nl
};
function wl() {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function Vm({
  icon: n,
  hideIcon: t = !1,
  title: a,
  titleColor: o,
  titleSize: l,
  titleWeight: s,
  description: r,
  actionLabel: c,
  onAction: i,
  bordered: u = !0,
  compact: m = !1
}) {
  const d = {
    ...o !== void 0 ? { color: o } : {},
    ...l !== void 0 ? { fontSize: l } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [ye.wrapper, u && !m ? ye.bordered : "", m ? ye.compact : ""].join(" ")
    },
    !t && /* @__PURE__ */ e.createElement("div", { className: ye.icon }, n != null ? n : /* @__PURE__ */ e.createElement(wl, null)),
    /* @__PURE__ */ e.createElement("p", { className: ye.title, style: d }, a),
    r && /* @__PURE__ */ e.createElement("p", { className: ye.description }, r),
    c && i && /* @__PURE__ */ e.createElement("button", { type: "button", className: ye.action, onClick: i }, c)
  );
}
const $l = "_wrapper_oide4_1", xl = "_toggle_oide4_7", Cl = "_toggleOpen_oide4_29", Bl = "_panel_oide4_34", Sl = "_text_oide4_41", Ie = {
  wrapper: $l,
  toggle: xl,
  toggleOpen: Cl,
  panel: Bl,
  text: Sl
};
function Jm({
  label: n,
  summaryText: t,
  open: a,
  onToggle: o
}) {
  return /* @__PURE__ */ e.createElement("div", { className: Ie.wrapper }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: [Ie.toggle, a ? Ie.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": a
    },
    n
  ), a && /* @__PURE__ */ e.createElement("div", { className: Ie.panel }, /* @__PURE__ */ e.createElement("p", { className: Ie.text }, t)));
}
const Ll = "_wrapper_96dw1_1", jl = "_labelRow_96dw1_8", Fl = "_label_96dw1_8", Ml = "_value_96dw1_21", Al = "_track_96dw1_27", Il = "_xs_96dw1_35", Dl = "_sm_96dw1_39", Rl = "_md_96dw1_43", Tl = "_square_96dw1_47", zl = "_fill_96dw1_51", ce = {
  wrapper: Ll,
  labelRow: jl,
  label: Fl,
  value: Ml,
  track: Al,
  xs: Il,
  sm: Dl,
  md: Rl,
  square: Tl,
  fill: zl
};
function Zm({
  value: n,
  max: t = 100,
  label: a,
  color: o = "#3B82F6",
  gradient: l,
  size: s = "md",
  rounded: r = !0,
  height: c,
  trackColor: i
}) {
  const u = t > 0 ? t : 100, m = Math.min(100, Math.max(0, n / u * 100)), d = l ? { width: `${m}%`, background: `linear-gradient(90deg, ${l[0]}, ${l[1]})` } : { width: `${m}%`, backgroundColor: o }, p = {
    ...c !== void 0 ? { height: c } : {},
    ...i !== void 0 ? { background: i } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: ce.wrapper }, a && /* @__PURE__ */ e.createElement("div", { className: ce.labelRow }, /* @__PURE__ */ e.createElement("span", { className: ce.label }, a), /* @__PURE__ */ e.createElement("span", { className: ce.value }, Math.round(m), "%")), /* @__PURE__ */ e.createElement("div", { className: [ce.track, ce[s], r ? "" : ce.square].join(" "), style: p }, /* @__PURE__ */ e.createElement("div", { className: [ce.fill, r ? "" : ce.square].join(" "), style: d })));
}
const Pl = "_list_aixh6_1", Ol = "_vertical_aixh6_8", Xl = "_horizontal_aixh6_13", Wl = "_item_aixh6_18", ql = "_iconWrap_aixh6_41", Gl = "_iconSvg_aixh6_51", Kl = "_spin_aixh6_56", Hl = "_label_aixh6_70", Ul = "_item_active_aixh6_82", Yl = "_item_done_aixh6_87", Vl = "_connector_aixh6_91", Jl = "_cardList_aixh6_114", Zl = "_cardItem_aixh6_122", Ql = "_card_pending_aixh6_133", es = "_card_active_aixh6_142", ts = "_card_done_aixh6_152", H = {
  list: Pl,
  vertical: Ol,
  horizontal: Xl,
  item: Wl,
  iconWrap: ql,
  iconSvg: Gl,
  spin: Kl,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: Hl,
  item_active: Ul,
  item_done: Yl,
  connector: Vl,
  cardList: Jl,
  cardItem: Zl,
  card_pending: Ql,
  card_active: es,
  card_done: ts
};
function ns({ status: n }) {
  return n === "done" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: H.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : n === "active" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: [H.iconSvg, H.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: H.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function Qm({
  steps: n,
  orientation: t = "vertical",
  variant: a = "timeline"
}) {
  const o = a === "card";
  return /* @__PURE__ */ e.createElement("ul", { className: [H.list, H[t], o ? H.cardList : ""].join(" ") }, n.map((l, s) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: `${l.label}-${s}`,
      className: [
        H.item,
        o ? H.cardItem : "",
        H[`item_${l.status}`],
        o ? H[`card_${l.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ e.createElement("span", { className: H.iconWrap }, /* @__PURE__ */ e.createElement(ns, { status: l.status })),
    /* @__PURE__ */ e.createElement("span", { className: H.label }, l.label),
    !o && s < n.length - 1 && /* @__PURE__ */ e.createElement("span", { className: H.connector })
  )));
}
const as = "_wrapper_1ohmw_1", os = "_icon_1ohmw_7", ls = "_dots_1ohmw_14", ss = "_dot_1ohmw_14", rs = "_sm_1ohmw_27", cs = "_md_1ohmw_32", Ee = {
  wrapper: as,
  icon: os,
  dots: ls,
  dot: ss,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: rs,
  md: cs
};
function ed({ withIcon: n, size: t = "md" }) {
  return /* @__PURE__ */ e.createElement("div", { className: Ee.wrapper }, n && /* @__PURE__ */ e.createElement("span", { className: Ee.icon }, n), /* @__PURE__ */ e.createElement("span", { className: [Ee.dots, Ee[t]].join(" ") }, /* @__PURE__ */ e.createElement("span", { className: Ee.dot }), /* @__PURE__ */ e.createElement("span", { className: Ee.dot }), /* @__PURE__ */ e.createElement("span", { className: Ee.dot })));
}
const is = "_container_85404_1", us = "_table_85404_9", ms = "_row_85404_31", ds = "_striped_85404_35", _s = "_clickable_85404_43", ps = "_alignLeft_85404_47", fs = "_alignCenter_85404_51", bs = "_alignRight_85404_55", hs = "_emptyCell_85404_59", ie = {
  container: is,
  table: us,
  row: ms,
  striped: ds,
  clickable: _s,
  alignLeft: ps,
  alignCenter: fs,
  alignRight: bs,
  emptyCell: hs
};
function td({
  columns: n,
  rows: t,
  striped: a = !0,
  onRowClick: o,
  emptyMessage: l = "데이터가 없습니다"
}) {
  const s = (r) => r === "center" ? ie.alignCenter : r === "right" ? ie.alignRight : ie.alignLeft;
  return /* @__PURE__ */ e.createElement("div", { className: ie.container }, /* @__PURE__ */ e.createElement("table", { className: ie.table }, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, n.map((r) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: r.key,
      className: s(r.align),
      style: r.width ? { width: r.width } : void 0
    },
    r.label
  )))), /* @__PURE__ */ e.createElement("tbody", null, t.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: ie.emptyCell, colSpan: n.length }, l)) : t.map((r, c) => {
    const i = [
      ie.row,
      a && c % 2 === 1 ? ie.striped : "",
      o ? ie.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: c,
        className: i,
        onClick: o ? () => o(r, c) : void 0
      },
      n.map((u) => /* @__PURE__ */ e.createElement("td", { key: u.key, className: s(u.align) }, r[u.key]))
    );
  }))));
}
const gs = "_grid_plbcd_1", ys = "_cell_plbcd_6", Es = "_primaryCell_plbcd_16", vs = "_label_plbcd_21", ks = "_value_plbcd_26", Ns = "_note_plbcd_32", we = {
  grid: gs,
  cell: ys,
  primaryCell: Es,
  label: vs,
  value: ks,
  note: Ns
};
function nd({
  items: n,
  columns: t = 4,
  primaryFirst: a = !1,
  cellBackground: o,
  cellBorderColor: l,
  labelColor: s,
  valueColor: r,
  primaryBackground: c,
  primaryLabelColor: i,
  primaryValueColor: u,
  primaryNoteColor: m
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: we.grid,
      style: { gridTemplateColumns: `repeat(${t}, 1fr)` }
    },
    n.map((d, p) => {
      const f = a && p === 0, b = [we.cell, f ? we.primaryCell : ""].filter(Boolean).join(" "), _ = {};
      o !== void 0 && (_.background = o), l !== void 0 && (_.borderColor = l), f && c !== void 0 && (_.background = c, _.borderColor = "transparent");
      const k = {};
      s !== void 0 && (k.color = s), f && i !== void 0 && (k.color = i);
      const $ = {};
      r !== void 0 && ($.color = r), f && u !== void 0 && ($.color = u);
      const S = {};
      return f && m !== void 0 && (S.color = m), /* @__PURE__ */ e.createElement("div", { key: `${d.label}-${p}`, className: b, style: _ }, /* @__PURE__ */ e.createElement("span", { className: we.label, style: k }, d.label), /* @__PURE__ */ e.createElement("span", { className: we.value, style: $ }, d.value), d.note && /* @__PURE__ */ e.createElement("span", { className: we.note, style: S }, d.note));
    })
  );
}
const ws = "_button_16ajt_1", $s = "_disabledSolid_16ajt_19", xs = "_icon_16ajt_26", Cs = "_label_16ajt_32", Bs = "_fullWidth_16ajt_37", Ss = "_sm_16ajt_41", Ls = "_md_16ajt_47", js = "_lg_16ajt_53", Fs = "_primary_16ajt_59", Ms = "_secondary_16ajt_70", As = "_outline_16ajt_81", Is = "_ghost_16ajt_93", Ds = "_active_16ajt_104", Rs = "_colorOverride_16ajt_116", Ts = "_gradient_16ajt_126", zs = "_dashed_16ajt_135", Ps = "_pill_16ajt_139", V = {
  button: ws,
  disabledSolid: $s,
  icon: xs,
  label: Cs,
  fullWidth: Bs,
  sm: Ss,
  md: Ls,
  lg: js,
  primary: Fs,
  secondary: Ms,
  outline: As,
  ghost: Is,
  active: Ds,
  colorOverride: Rs,
  gradient: Ts,
  dashed: zs,
  pill: Ps
};
function ad({
  variant: n = "primary",
  size: t = "md",
  icon: a,
  iconPosition: o = "leading",
  disabled: l = !1,
  disabledVariant: s = "dim",
  onClick: r,
  children: c,
  fullWidth: i = !1,
  type: u = "button",
  active: m = !1,
  color: d,
  background: p,
  borderColor: f,
  hoverColor: b,
  hoverBackground: _,
  gradient: k,
  borderStyle: $ = "solid",
  shape: S = "rounded"
}) {
  const g = d !== void 0 || f !== void 0 || b !== void 0 || _ !== void 0, N = [
    V.button,
    V[n],
    V[t],
    i ? V.fullWidth : "",
    l && s === "solid" ? V.disabledSolid : "",
    m ? V.active : "",
    g ? V.colorOverride : "",
    k || p ? V.gradient : "",
    $ === "dashed" ? V.dashed : "",
    S === "pill" ? V.pill : ""
  ].filter(Boolean).join(" "), y = {
    ...d !== void 0 ? { "--ax-btn-color": d } : {},
    ...f !== void 0 ? { "--ax-btn-border": f } : {},
    ...b !== void 0 ? { "--ax-btn-hover-color": b } : {},
    ..._ !== void 0 ? { "--ax-btn-hover-bg": _ } : {},
    ...k ? { background: `linear-gradient(135deg, ${k[0]}, ${k[1]})` } : {},
    ...p !== void 0 ? { background: p } : {}
  }, v = a && /* @__PURE__ */ e.createElement("span", { className: V.icon }, a);
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: u,
      className: N,
      style: y,
      disabled: l,
      onClick: r
    },
    o === "leading" && v,
    /* @__PURE__ */ e.createElement("span", { className: V.label }, c),
    o === "trailing" && v
  );
}
const Os = "_iconButton_1oiog_1", Xs = "_sm_1oiog_18", Ws = "_md_1oiog_23", qs = "_lg_1oiog_28", Gs = "_plain_1oiog_33", Ks = "_outline_1oiog_42", Hs = "_circle_1oiog_53", Us = "_bordered_1oiog_62", Ys = "_tint_1oiog_73", Vs = "_active_1oiog_81", Js = "_hoverBgOverride_1oiog_92", Zs = "_gradient_1oiog_96", he = {
  iconButton: Os,
  sm: Xs,
  md: Ws,
  lg: qs,
  plain: Gs,
  outline: Ks,
  circle: Hs,
  bordered: Us,
  tint: Ys,
  active: Vs,
  hoverBgOverride: Js,
  gradient: Zs
};
function od({
  icon: n,
  title: t,
  active: a = !1,
  size: o = "md",
  variant: l = "plain",
  onClick: s,
  onMouseDown: r,
  disabled: c = !1,
  color: i,
  hoverColor: u,
  bordered: m = !1,
  borderColor: d = "#e2e8f0",
  borderHoverColor: p = "#3b82f6",
  tint: f = !1,
  tintColor: b = "#eef4ff",
  tintHoverColor: _ = "#dbeafe",
  hoverBackground: k,
  gradient: $
}) {
  const S = typeof o == "number", g = [
    he.iconButton,
    S ? "" : he[o],
    he[l],
    a ? he.active : "",
    m ? he.bordered : "",
    f ? he.tint : "",
    k !== void 0 ? he.hoverBgOverride : "",
    $ ? he.gradient : ""
  ].filter(Boolean).join(" "), N = {
    ...S ? { width: o, height: o } : {},
    ...i !== void 0 ? { "--ax-icon-color": i } : {},
    ...u !== void 0 ? { "--ax-icon-hover": u } : {},
    ...m ? { "--ax-icon-border": d, "--ax-icon-border-hover": p } : {},
    ...f ? { "--ax-icon-tint": b, "--ax-icon-tint-hover": _ } : {},
    ...k !== void 0 ? { "--ax-icon-hover-bg": k } : {},
    ...$ ? { background: `linear-gradient(135deg, ${$[0]}, ${$[1]})` } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: g,
      style: N,
      onClick: s,
      onMouseDown: r,
      disabled: c,
      title: t,
      "aria-label": t
    },
    n
  );
}
const Qs = "_wrapper_wrch3_1", er = "_searchIcon_wrch3_18", tr = "_input_wrch3_26", nr = "_clearButton_wrch3_40", ar = "_hint_wrch3_60", De = {
  wrapper: Qs,
  searchIcon: er,
  input: tr,
  clearButton: nr,
  hint: ar
}, or = /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ e.createElement("path", { d: "M21 21l-4.35-4.35" }));
function ld({
  value: n,
  onChange: t,
  placeholder: a,
  hint: o,
  onSubmit: l,
  onClear: s
}) {
  const r = (c) => {
    c.key === "Enter" && (l == null || l());
  };
  return /* @__PURE__ */ e.createElement("div", { className: De.wrapper }, /* @__PURE__ */ e.createElement("span", { className: De.searchIcon }, or), /* @__PURE__ */ e.createElement(
    "input",
    {
      type: "text",
      className: De.input,
      value: n,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: r
    }
  ), s && n.length > 0 && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: De.clearButton,
      onClick: s,
      "aria-label": "clear"
    },
    /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ), o && /* @__PURE__ */ e.createElement("span", { className: De.hint }, o));
}
const lr = "_control_1kv40_1", sr = "_option_1kv40_10", rr = "_active_1kv40_28", cr = "_sm_1kv40_37", ir = "_md_1kv40_43", ur = "_dot_1kv40_49", mr = "_count_1kv40_56", dr = "_outline_1kv40_70", _r = "_outlineOption_1kv40_75", ue = {
  control: lr,
  option: sr,
  active: rr,
  sm: cr,
  md: ir,
  dot: ur,
  count: mr,
  outline: dr,
  outlineOption: _r
};
function sd({
  options: n,
  value: t,
  onChange: a,
  size: o = "md",
  variant: l = "filled",
  activeBackground: s,
  activeColor: r,
  activeBorderColor: c
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [ue.control, ue[o], l === "outline" ? ue.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    n.map((i) => {
      const u = i.value === t, m = u ? {
        ...s !== void 0 ? { background: s } : {},
        ...r !== void 0 ? { color: r } : {},
        ...c !== void 0 ? { borderColor: c } : {}
      } : void 0;
      return /* @__PURE__ */ e.createElement(
        "button",
        {
          key: i.value,
          type: "button",
          role: "tab",
          "aria-selected": u,
          className: [ue.option, u ? ue.active : "", l === "outline" ? ue.outlineOption : ""].filter(Boolean).join(" "),
          style: m,
          onClick: () => a(i.value)
        },
        i.dot && /* @__PURE__ */ e.createElement("span", { className: ue.dot, style: { backgroundColor: i.dot } }),
        /* @__PURE__ */ e.createElement("span", { className: ue.label }, i.label),
        typeof i.count == "number" && /* @__PURE__ */ e.createElement("span", { className: ue.count }, i.count)
      );
    })
  );
}
const pr = "_chip_8jgxm_1", fr = "_clickable_8jgxm_14", br = "_suggested_8jgxm_23", hr = "_readonly_8jgxm_33", gr = "_plusIcon_8jgxm_39", yr = "_label_8jgxm_45", Er = "_removeButton_8jgxm_50", $e = {
  chip: pr,
  clickable: fr,
  default: "_default_8jgxm_18",
  suggested: br,
  readonly: hr,
  plusIcon: gr,
  label: yr,
  removeButton: Er
};
function rd({
  label: n,
  variant: t = "default",
  onRemove: a,
  onClick: o,
  background: l,
  textColor: s,
  borderColor: r
}) {
  const c = [$e.chip, $e[t], o ? $e.clickable : ""].filter(Boolean).join(" "), u = l !== void 0 || s !== void 0 || r !== void 0 ? {
    ...l !== void 0 ? { background: l } : {},
    ...s !== void 0 ? { color: s } : {},
    ...r !== void 0 ? { borderColor: r } : {}
  } : {}, m = t !== "readonly" && !!a, d = /* @__PURE__ */ e.createElement(e.Fragment, null, t === "suggested" && /* @__PURE__ */ e.createElement("span", { className: $e.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ e.createElement("span", { className: $e.label }, n), m && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: $e.removeButton,
      "aria-label": `remove ${n}`,
      onClick: (p) => {
        p.stopPropagation(), a == null || a();
      }
    },
    /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: c,
      style: u,
      onClick: o,
      onKeyDown: (p) => {
        (p.key === "Enter" || p.key === " ") && (p.preventDefault(), o());
      }
    },
    d
  ) : /* @__PURE__ */ e.createElement("span", { className: c, style: u }, d);
}
const vr = "_wrapper_15dm4_1", kr = "_disabled_15dm4_8", Nr = "_track_15dm4_13", wr = "_checked_15dm4_30", $r = "_thumb_15dm4_34", xr = "_label_15dm4_50", xe = {
  wrapper: vr,
  disabled: kr,
  track: Nr,
  checked: wr,
  thumb: $r,
  label: xr
};
function cd({
  checked: n,
  onChange: t,
  labelOn: a,
  labelOff: o,
  disabled: l = !1,
  color: s
}) {
  const r = n ? a : o;
  return /* @__PURE__ */ e.createElement("label", { className: [xe.wrapper, l ? xe.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": n,
      disabled: l,
      className: [xe.track, n ? xe.checked : ""].filter(Boolean).join(" "),
      style: n && s !== void 0 ? { background: s } : void 0,
      onClick: () => !l && t(!n)
    },
    /* @__PURE__ */ e.createElement("span", { className: xe.thumb })
  ), r && /* @__PURE__ */ e.createElement("span", { className: xe.label }, r));
}
const Cr = "_card_1uh3t_1", Br = "_active_1uh3t_24", Sr = "_iconChip_1uh3t_29", Lr = "_body_1uh3t_41", jr = "_label_1uh3t_48", Fr = "_description_1uh3t_54", Ce = {
  card: Cr,
  active: Br,
  iconChip: Sr,
  body: Lr,
  label: jr,
  description: Fr
};
function id(n) {
  const { icon: t, label: a, description: o, active: l = !1, onClick: s } = n;
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${Ce.card} ${l ? Ce.active : ""}`,
      onClick: s,
      "aria-pressed": l
    },
    /* @__PURE__ */ e.createElement("span", { className: Ce.iconChip }, t),
    /* @__PURE__ */ e.createElement("span", { className: Ce.body }, /* @__PURE__ */ e.createElement("span", { className: Ce.label }, a), o && /* @__PURE__ */ e.createElement("span", { className: Ce.description }, o))
  );
}
const Mr = "_breadcrumb_zkol9_1", Ar = "_list_zkol9_6", Ir = "_item_zkol9_16", Dr = "_link_zkol9_22", Rr = "_plain_zkol9_43", Tr = "_current_zkol9_48", zr = "_separator_zkol9_54", ve = {
  breadcrumb: Mr,
  list: Ar,
  item: Ir,
  link: Dr,
  plain: Rr,
  current: Tr,
  separator: zr
};
function ud(n) {
  const { items: t, separator: a = "/", textColor: o, hoverColor: l, currentColor: s } = n, r = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...l !== void 0 ? { "--ax-bc-hover": l } : {},
    ...s !== void 0 ? { "--ax-bc-current": s } : {}
  };
  return /* @__PURE__ */ e.createElement("nav", { className: ve.breadcrumb, "aria-label": "breadcrumb", style: r }, /* @__PURE__ */ e.createElement("ol", { className: ve.list }, t.map((c, i) => {
    const u = i === t.length - 1;
    return /* @__PURE__ */ e.createElement("li", { key: i, className: ve.item }, u ? /* @__PURE__ */ e.createElement("span", { className: ve.current, "aria-current": "page" }, c.label) : c.onClick ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: ve.link,
        onClick: c.onClick
      },
      c.label
    ) : /* @__PURE__ */ e.createElement("span", { className: ve.plain }, c.label), !u && /* @__PURE__ */ e.createElement("span", { className: ve.separator, "aria-hidden": "true" }, a));
  })));
}
const Pr = "_treeItem_1ouqz_1", Or = "_active_1ouqz_18", Xr = "_chevron_1ouqz_28", Wr = "_chevronExpanded_1ouqz_48", qr = "_chevronSpacer_1ouqz_52", Gr = "_icon_1ouqz_57", Kr = "_label_1ouqz_69", Hr = "_count_1ouqz_76", Ur = "_dark_1ouqz_86", me = {
  treeItem: Pr,
  active: Or,
  chevron: Xr,
  chevronExpanded: Wr,
  chevronSpacer: qr,
  icon: Gr,
  label: Kr,
  count: Hr,
  dark: Ur
};
function md(n) {
  const {
    icon: t,
    label: a,
    count: o,
    indent: l = 0,
    active: s = !1,
    expandable: r = !1,
    expanded: c = !1,
    theme: i = "light",
    onToggleExpand: u,
    onClick: m
  } = n, d = (f) => {
    f.stopPropagation(), u == null || u();
  }, p = i === "dark" ? me.dark : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${me.treeItem} ${p} ${s ? me.active : ""}`,
      style: { paddingLeft: 12 + l * 16 },
      onClick: m,
      role: "treeitem",
      "aria-selected": s,
      "aria-expanded": r ? c : void 0
    },
    r ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${me.chevron} ${c ? me.chevronExpanded : ""}`,
        onClick: d,
        "aria-label": c ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ e.createElement("span", { className: me.chevronSpacer }),
    t && /* @__PURE__ */ e.createElement("span", { className: me.icon }, t),
    /* @__PURE__ */ e.createElement("span", { className: me.label }, a),
    typeof o == "number" && /* @__PURE__ */ e.createElement("span", { className: me.count }, o)
  );
}
const Yr = "_backdrop_gstyy_1", Vr = "_panel_gstyy_9", Jr = "_right_gstyy_21", Zr = "_left_gstyy_27", Qr = "_header_gstyy_51", ec = "_icon_gstyy_59", tc = "_titleGroup_gstyy_66", nc = "_kicker_gstyy_71", ac = "_title_gstyy_66", oc = "_subtitle_gstyy_87", lc = "_closeButton_gstyy_93", sc = "_body_gstyy_115", rc = "_footer_gstyy_123", Y = {
  backdrop: Yr,
  panel: Vr,
  right: Jr,
  left: Zr,
  header: Qr,
  icon: ec,
  titleGroup: tc,
  kicker: nc,
  title: ac,
  subtitle: oc,
  closeButton: lc,
  body: sc,
  footer: rc
};
function dd({
  open: n,
  onClose: t,
  icon: a,
  kicker: o,
  title: l,
  titleSize: s,
  titleWeight: r,
  subtitle: c,
  footer: i,
  children: u,
  side: m = "right",
  headerBackground: d,
  topOffset: p
}) {
  if (!n)
    return null;
  const f = [Y.panel, m === "left" ? Y.left : Y.right].filter(Boolean).join(" "), b = {
    ...s !== void 0 ? { fontSize: s } : {},
    ...r !== void 0 ? { fontWeight: r } : {}
  }, _ = p !== void 0 ? { top: p, height: `calc(100vh - ${p}px)` } : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: Y.backdrop, onClick: t }, /* @__PURE__ */ e.createElement("div", { className: f, style: _, onClick: (k) => k.stopPropagation() }, /* @__PURE__ */ e.createElement("div", { className: Y.header, style: d !== void 0 ? { background: d } : void 0 }, a && /* @__PURE__ */ e.createElement("span", { className: Y.icon }, a), /* @__PURE__ */ e.createElement("div", { className: Y.titleGroup }, o && /* @__PURE__ */ e.createElement("p", { className: Y.kicker }, o), /* @__PURE__ */ e.createElement("h2", { className: Y.title, style: b }, l), c && /* @__PURE__ */ e.createElement("p", { className: Y.subtitle }, c)), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: Y.closeButton,
      onClick: t,
      "aria-label": "닫기"
    },
    "×"
  )), /* @__PURE__ */ e.createElement("div", { className: Y.body }, u), i && /* @__PURE__ */ e.createElement("div", { className: Y.footer }, i)));
}
const cc = "_backdrop_6kso7_1", ic = "_menu_6kso7_8", uc = "_alignRight_6kso7_24", mc = "_alignLeft_6kso7_28", dc = "_item_6kso7_32", _c = "_itemIcon_6kso7_50", pc = "_itemText_6kso7_59", fc = "_itemLabel_6kso7_66", bc = "_itemDescription_6kso7_72", hc = "_danger_6kso7_77", ne = {
  backdrop: cc,
  menu: ic,
  alignRight: uc,
  alignLeft: mc,
  item: dc,
  itemIcon: _c,
  itemText: pc,
  itemLabel: fc,
  itemDescription: bc,
  danger: hc
};
function _d({
  open: n,
  onClose: t,
  items: a,
  anchor: o = "right"
}) {
  if (!n)
    return null;
  const l = [ne.menu, o === "left" ? ne.alignLeft : ne.alignRight].filter(Boolean).join(" "), s = (r) => {
    r.onClick(), t();
  };
  return /* @__PURE__ */ e.createElement(nn, null, /* @__PURE__ */ e.createElement("div", { className: ne.backdrop, onClick: t }), /* @__PURE__ */ e.createElement("div", { className: l, onClick: (r) => r.stopPropagation() }, a.map((r, c) => {
    const i = [ne.item, r.danger ? ne.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: c,
        type: "button",
        className: i,
        onClick: () => s(r)
      },
      r.icon && /* @__PURE__ */ e.createElement("span", { className: ne.itemIcon }, r.icon),
      /* @__PURE__ */ e.createElement("span", { className: ne.itemText }, /* @__PURE__ */ e.createElement("span", { className: ne.itemLabel }, r.label), r.description && /* @__PURE__ */ e.createElement("span", { className: ne.itemDescription }, r.description))
    );
  })));
}
const gc = "_backdrop_3pc9i_1", yc = "_card_3pc9i_12", Ec = "_header_3pc9i_23", vc = "_icon_3pc9i_31", kc = "_titleGroup_3pc9i_38", Nc = "_title_3pc9i_38", wc = "_subtitle_3pc9i_50", $c = "_closeButton_3pc9i_56", xc = "_body_3pc9i_78", Cc = "_footer_3pc9i_85", ae = {
  backdrop: gc,
  card: yc,
  header: Ec,
  icon: vc,
  titleGroup: kc,
  title: Nc,
  subtitle: wc,
  closeButton: $c,
  body: xc,
  footer: Cc
};
function pd({
  open: n,
  onClose: t,
  icon: a,
  title: o,
  subtitle: l,
  footer: s,
  width: r = 480,
  children: c
}) {
  if (!n)
    return null;
  const i = typeof r == "number" ? `${r}px` : r;
  return /* @__PURE__ */ e.createElement("div", { className: ae.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: ae.card,
      style: { width: i },
      onClick: (u) => u.stopPropagation()
    },
    /* @__PURE__ */ e.createElement("div", { className: ae.header }, a && /* @__PURE__ */ e.createElement("span", { className: ae.icon }, a), /* @__PURE__ */ e.createElement("div", { className: ae.titleGroup }, /* @__PURE__ */ e.createElement("h2", { className: ae.title }, o), l && /* @__PURE__ */ e.createElement("p", { className: ae.subtitle }, l)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: ae.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: ae.body }, c),
    s && /* @__PURE__ */ e.createElement("div", { className: ae.footer }, s)
  ));
}
const Bc = "_page_1f94v_5", Sc = "_inner_1f94v_18", Nt = {
  page: Bc,
  inner: Sc
};
function fd({
  gnbHeight: n = 64,
  minWidth: t = 1024,
  className: a = "",
  style: o,
  children: l
}) {
  return /* @__PURE__ */ e.createElement(
    "main",
    {
      className: [Nt.page, "axe-page", a].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${n}px)`, ...o }
    },
    /* @__PURE__ */ e.createElement("div", { className: Nt.inner, style: { minWidth: t } }, l)
  );
}
const Lc = "_bar_j0oph_1", jc = "_menu_j0oph_9", Fc = "_title_j0oph_19", Mc = "_info_j0oph_21", Ac = "_badge_j0oph_29", Ic = "_badge_muted_j0oph_30", Dc = "_badge_ok_j0oph_31", Rc = "_badge_warn_j0oph_32", Tc = "_meta_j0oph_34", zc = "_actions_j0oph_18", Pc = "_notice_j0oph_48", Oc = "_notice_info_j0oph_53", Xc = "_notice_ok_j0oph_54", Wc = "_notice_err_j0oph_55", oe = {
  bar: Lc,
  menu: jc,
  title: Fc,
  info: Mc,
  badge: Ac,
  badge_muted: Ic,
  badge_ok: Dc,
  badge_warn: Rc,
  meta: Tc,
  actions: zc,
  notice: Pc,
  notice_info: Oc,
  notice_ok: Xc,
  notice_err: Wc
};
function bd({
  title: n,
  onMenu: t,
  info: a,
  badge: o,
  meta: l,
  notice: s,
  children: r
}) {
  var c;
  return /* @__PURE__ */ e.createElement("header", { className: oe.bar }, t && /* @__PURE__ */ e.createElement("button", { type: "button", className: oe.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ e.createElement("h1", { className: oe.title }, n), a && /* @__PURE__ */ e.createElement("span", { className: oe.info, title: a }, "i"), (Array.isArray(o) ? o : [o]).filter(Boolean).map((i, u) => {
    var m;
    return /* @__PURE__ */ e.createElement("span", { key: u, className: [oe.badge, oe[`badge_${(m = i.tone) != null ? m : "muted"}`]].join(" ") }, i.label);
  }), l && /* @__PURE__ */ e.createElement("span", { className: oe.meta }, l), /* @__PURE__ */ e.createElement("span", { className: oe.actions }, s && s.text && /* @__PURE__ */ e.createElement("span", { className: [oe.notice, oe[`notice_${(c = s.tone) != null ? c : "info"}`]].join(" "), role: "status" }, s.text), r));
}
const qc = "_btn_1i6cr_1", Gc = "_primary_1i6cr_18", Kc = "_dark_1i6cr_20", Hc = "_kbd_1i6cr_23", Uc = "_iconBtn_1i6cr_26", Ye = {
  btn: qc,
  primary: Gc,
  dark: Kc,
  kbd: Hc,
  iconBtn: Uc
};
function hd({
  variant: n = "default",
  kbd: t,
  children: a,
  className: o = "",
  type: l = "button",
  ...s
}) {
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: l,
      className: [Ye.btn, Ye[n], o].filter(Boolean).join(" "),
      ...s
    },
    a,
    t && /* @__PURE__ */ e.createElement("kbd", { className: Ye.kbd }, t)
  );
}
function gd({ label: n, children: t, className: a = "", type: o = "button", ...l }) {
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: o,
      className: [Ye.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": n,
      title: n,
      ...l
    },
    t
  );
}
const Yc = {
  print: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ e.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ e.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  trash: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ e.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ e.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ e.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Vc = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function yd({ name: n, className: t }) {
  return /* @__PURE__ */ e.createElement("span", { className: t, "aria-hidden": "true" }, Vc[n]);
}
function Ed({ name: n, size: t = 15, className: a }) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    Yc[n]
  );
}
const Jc = "_underline_145xy_2", Zc = "_active_145xy_24", Qc = "_segmented_145xy_33", Qe = {
  underline: Jc,
  active: Zc,
  segmented: Qc
};
function vd({
  items: n,
  value: t,
  onChange: a,
  variant: o = "underline",
  className: l = "",
  "aria-label": s
}) {
  return /* @__PURE__ */ e.createElement(
    "nav",
    {
      className: [o === "segmented" ? Qe.segmented : Qe.underline, l].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": s
    },
    n.map((r) => /* @__PURE__ */ e.createElement(
      "button",
      {
        key: r.key,
        type: "button",
        role: "tab",
        "aria-selected": r.key === t,
        className: r.key === t ? Qe.active : "",
        onClick: () => a(r.key)
      },
      r.label
    ))
  );
}
const ei = "_bar_m6xfy_1", ti = "_actions_m6xfy_17", ni = "_field_m6xfy_24", ai = "_fieldLabel_m6xfy_25", oi = "_readout_m6xfy_36", li = "_search_m6xfy_47", si = "_detail_m6xfy_60", ri = "_pill_m6xfy_72", ci = "_hint_m6xfy_83", de = {
  bar: ei,
  actions: ti,
  field: ni,
  fieldLabel: ai,
  readout: oi,
  search: li,
  detail: si,
  pill: ri,
  hint: ci
};
function kd({
  children: n,
  onSearch: t,
  searchLabel: a = "조회",
  detailSearch: o = !1,
  onDetailSearch: l,
  detailLabel: s = "상세검색",
  trailing: r
}) {
  return /* @__PURE__ */ e.createElement("section", { className: de.bar }, n, /* @__PURE__ */ e.createElement("span", { className: de.actions }, r, o && /* @__PURE__ */ e.createElement("button", { type: "button", className: de.detail, onClick: l }, "⌕ ", s), t && /* @__PURE__ */ e.createElement("button", { type: "button", className: de.search, onClick: t }, "⌕ ", a)));
}
function Nd({ label: n, children: t }) {
  return /* @__PURE__ */ e.createElement("label", { className: de.field }, /* @__PURE__ */ e.createElement("span", { className: de.fieldLabel }, n), t);
}
function wd({ children: n }) {
  return /* @__PURE__ */ e.createElement("span", { className: de.readout }, n);
}
function $d({ children: n }) {
  return /* @__PURE__ */ e.createElement("span", { className: de.pill, role: "status" }, n);
}
function xd({ children: n }) {
  return /* @__PURE__ */ e.createElement("span", { className: de.hint }, n);
}
class Xt {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((o) => {
        try {
          for (const l of o) {
            const s = l.borderBoxSize[0];
            this._callback({ width: s.inlineSize, height: s.blockSize }, l);
          }
        } catch (l) {
          console.error(l);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
const ii = "_card_15ug2_2", ui = "_grow_15ug2_16", mi = "_head_15ug2_18", di = "_title_15ug2_27", _i = "_trailing_15ug2_28", pi = "_scroll_15ug2_9", fi = "_foot_15ug2_44", bi = "_strip_15ug2_46", hi = "_spacer_15ug2_47", gi = "_table_15ug2_49", yi = "_fixed_15ug2_50", Ei = "_fz_15ug2_64", vi = "_fzEdge_15ug2_76", ki = "_frozen_15ug2_83", K = {
  card: ii,
  grow: ui,
  head: mi,
  title: di,
  trailing: _i,
  scroll: pi,
  foot: fi,
  strip: bi,
  spacer: hi,
  table: gi,
  fixed: yi,
  fz: Ei,
  fzEdge: vi,
  frozen: ki
};
function wt({ cols: n }) {
  return !n || !n.length ? null : /* @__PURE__ */ e.createElement("colgroup", null, n.map((t, a) => /* @__PURE__ */ e.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const $t = /* @__PURE__ */ new Set();
function Ni(n) {
  var o;
  if (typeof process == "undefined" || ((o = process.env) == null ? void 0 : o.NODE_ENV) === "production") return;
  const t = [];
  if (n.querySelectorAll("td.axe-money").forEach((l) => {
    var s, r;
    l.scrollWidth > l.clientWidth + 1 && t.push((r = (s = l.textContent) == null ? void 0 : s.trim()) != null ? r : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  $t.has(a) || ($t.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function xt(n, t, a) {
  if (!n) return;
  const o = /* @__PURE__ */ new Map();
  for (const l of Array.from(n.rows)) {
    o.forEach((r, c) => {
      r <= 1 ? o.delete(c) : o.set(c, r - 1);
    });
    let s = 0;
    for (const r of Array.from(l.cells)) {
      for (; o.has(s); ) s += 1;
      const c = r.colSpan || 1, i = t > 0 && s + c <= t;
      if (r.classList.toggle(K.fz, i), r.classList.toggle(K.fzEdge, i && s + c === t), r.style.left = i ? `${a[s]}px` : "", r.rowSpan > 1) for (let u = s; u < s + c; u += 1) o.set(u, r.rowSpan);
      s += c;
    }
  }
}
function Cd({
  cols: n,
  footer: t,
  title: a,
  trailing: o,
  grow: l,
  fixed: s,
  stickyCols: r = 0,
  className: c = "",
  children: i
}) {
  const u = s || n !== void 0 && n.length > 0, { stick: m, offsets: d } = ge(() => {
    const y = Math.max(Math.trunc(r), 0), v = [];
    if (y === 0 || !n) return { stick: 0, offsets: v };
    let j = 0, I = 0;
    for (let C = 0; C < y; C += 1) {
      const L = n[C];
      if (typeof L != "number") break;
      v.push(j), j += L, I += 1;
    }
    return { stick: I, offsets: v };
  }, [n, r]), p = [K.table, u ? K.fixed : "", m > 0 ? K.frozen : ""].filter(Boolean).join(" "), f = X(null), b = X(null), _ = X(null), k = X(null), $ = X(0), S = () => {
    const y = f.current, v = _.current, j = k.current;
    if (!y || !v || !j) return;
    const I = y.scrollWidth;
    j.style.width = I + "px", v.style.display = I > y.clientWidth + 1 ? "" : "none";
    const C = y.offsetWidth - y.clientWidth;
    v.style.paddingRight = C + "px", b.current && (b.current.style.paddingRight = C + "px"), Ni(y);
  };
  Z(() => {
    const y = f.current;
    if (!y) return;
    const v = new Xt(y, S);
    return () => v.detach();
  }, []), At(() => {
    var y, v, j, I;
    (m > 0 || $.current > 0) && (xt((v = (y = f.current) == null ? void 0 : y.querySelector("table")) != null ? v : null, m, d), xt((I = (j = b.current) == null ? void 0 : j.querySelector("table")) != null ? I : null, m, d)), $.current = m, S();
  });
  const g = (y) => {
    const v = y.target.scrollLeft;
    f.current && (f.current.scrollLeft = v), b.current && (b.current.scrollLeft = v);
  }, N = (y) => {
    const v = y.target.scrollLeft;
    b.current && (b.current.scrollLeft = v), _.current && (_.current.scrollLeft = v);
  };
  return /* @__PURE__ */ e.createElement("div", { className: [K.card, l ? K.grow : "", c].filter(Boolean).join(" ") }, (a !== void 0 || o !== void 0) && /* @__PURE__ */ e.createElement("header", { className: K.head }, /* @__PURE__ */ e.createElement("span", { className: K.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: K.trailing }, o)), /* @__PURE__ */ e.createElement("div", { className: K.scroll, ref: f, onScroll: N }, /* @__PURE__ */ e.createElement("table", { className: p }, /* @__PURE__ */ e.createElement(wt, { cols: n }), i)), t && /* @__PURE__ */ e.createElement("div", { className: K.foot, ref: b }, /* @__PURE__ */ e.createElement("table", { className: p }, /* @__PURE__ */ e.createElement(wt, { cols: n }), /* @__PURE__ */ e.createElement("tbody", null, t))), /* @__PURE__ */ e.createElement("div", { className: K.strip, ref: _, onScroll: g }, /* @__PURE__ */ e.createElement("div", { ref: k, className: K.spacer })));
}
const wi = 7.09, $i = 3.88, xi = 4.46, Ci = 16, Bi = 2;
function Si(n, t = {}) {
  var s;
  const a = Math.max(1, n), o = Math.floor((a - 1) / 3), l = a * wi + o * $i + (t.negative ? xi : 0) + Ci + Bi;
  return Math.max(Math.ceil(l), (s = t.min) != null ? s : 0);
}
function Bd(n, t = {}) {
  var l, s;
  let a = 0, o = (l = t.negative) != null ? l : !1;
  for (const r of n) {
    if (r == null || r === "") continue;
    const c = typeof r == "number" ? r : Number(String(r).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (o = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((s = t.min) != null ? s : 96, 96) : Si(a, { ...t, negative: o });
}
function Sd(n) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", n.appendChild(t);
  const a = (r) => (t.textContent = r, t.getBoundingClientRect().width), o = a("000000000000"), l = a("000,000,000,000"), s = a("-000,000,000,000");
  return t.remove(), { digit: o / 12, comma: (l - o) / 3, minus: s - l };
}
const Li = "_card_1xyfv_1", ji = "_accent_1xyfv_8", Fi = "_grow_1xyfv_9", Mi = "_head_1xyfv_11", Ai = "_title_1xyfv_20", Ii = "_trailing_1xyfv_21", Di = "_summary_1xyfv_24", Ri = "_sumHead_1xyfv_25", Ti = "_sumTotal_1xyfv_34", zi = "_tone_warn_1xyfv_35", Pi = "_tone_ok_1xyfv_36", Oi = "_sumList_1xyfv_38", Xi = "_sumEm_1xyfv_47", Wi = "_sumFoot_1xyfv_49", qi = "_sumNote_1xyfv_58", W = {
  card: Li,
  accent: ji,
  grow: Fi,
  head: Mi,
  title: Ai,
  trailing: Ii,
  summary: Di,
  sumHead: Ri,
  sumTotal: Ti,
  tone_warn: zi,
  tone_ok: Pi,
  sumList: Oi,
  sumEm: Xi,
  sumFoot: Wi,
  sumNote: qi
};
function Ld({
  title: n,
  trailing: t,
  accent: a,
  grow: o,
  className: l = "",
  children: s
}) {
  return /* @__PURE__ */ e.createElement(
    "section",
    {
      className: [W.card, a ? W.accent : "", o ? W.grow : "", l].filter(Boolean).join(" ")
    },
    n !== void 0 && /* @__PURE__ */ e.createElement("header", { className: W.head }, /* @__PURE__ */ e.createElement("span", { className: W.title }, n), t && /* @__PURE__ */ e.createElement("span", { className: W.trailing }, t)),
    s
  );
}
function jd({
  title: n,
  total: t,
  items: a,
  footerLabel: o,
  footerValue: l,
  note: s,
  tone: r = "default",
  children: c
}) {
  return /* @__PURE__ */ e.createElement("section", { className: [W.card, W.accent, W.summary, W[`tone_${r}`]].join(" ") }, /* @__PURE__ */ e.createElement("header", { className: W.sumHead }, /* @__PURE__ */ e.createElement("span", null, n), t !== void 0 && /* @__PURE__ */ e.createElement("strong", { className: W.sumTotal }, t)), /* @__PURE__ */ e.createElement("ul", { className: W.sumList }, a.map((i, u) => {
    var m;
    return /* @__PURE__ */ e.createElement("li", { key: (m = i.key) != null ? m : u, className: i.em ? W.sumEm : "" }, /* @__PURE__ */ e.createElement("span", null, i.label), /* @__PURE__ */ e.createElement("strong", null, i.value));
  })), c, o !== void 0 && /* @__PURE__ */ e.createElement("footer", { className: W.sumFoot }, /* @__PURE__ */ e.createElement("span", null, o), /* @__PURE__ */ e.createElement("strong", null, l)), s && /* @__PURE__ */ e.createElement("div", { className: W.sumNote }, s));
}
const Gi = "_orbitPortalRoot_177qv_2", Ki = {
  orbitPortalRoot: Gi
};
class Wt extends It {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || Ki.orbitPortalRoot, a = Array.from(document.body.childNodes).find((o) => o.className === t);
      if (!a) {
        const o = document.createElement("div");
        return o.className = t, document.body.appendChild(o), o;
      }
      return a;
    };
  }
  render() {
    return sn(this.props.children, this.getPortalRoot());
  }
}
const Hi = "_root_18gbr_1", Ui = "_codeInput_18gbr_3", Yi = "_pickBtn_18gbr_6", Vi = "_popup_18gbr_21", Ji = "_popupHead_18gbr_35", Zi = "_searchRow_18gbr_45", Qi = "_list_18gbr_49", eu = "_current_18gbr_58", tu = "_empty_18gbr_62", nu = "_summaryBtn_18gbr_70", au = "_ov_18gbr_91", ou = "_modal_18gbr_102", lu = "_head_18gbr_113", su = "_sub_18gbr_121", ru = "_x_18gbr_123", cu = "_body_18gbr_140", iu = "_chips_18gbr_148", uu = "_chip_18gbr_148", mu = "_chipOn_18gbr_162", du = "_search_18gbr_45", _u = "_tbl_18gbr_181", pu = "_row_18gbr_211", fu = "_rowCursor_18gbr_213", bu = "_rowPicked_18gbr_214", hu = "_chk_18gbr_216", gu = "_tdLeft_18gbr_217", yu = "_tdCenter_18gbr_218", Eu = "_emptyCell_18gbr_220", vu = "_stop_18gbr_222", ku = "_more_18gbr_233", Nu = "_pager_18gbr_245", wu = "_note_18gbr_258", $u = "_foot_18gbr_261", xu = "_ghost_18gbr_270", Cu = "_primary_18gbr_282", x = {
  root: Hi,
  codeInput: Ui,
  pickBtn: Yi,
  popup: Vi,
  popupHead: Ji,
  searchRow: Zi,
  list: Qi,
  current: eu,
  empty: tu,
  summaryBtn: nu,
  ov: au,
  modal: ou,
  head: lu,
  sub: su,
  x: ru,
  body: cu,
  chips: iu,
  chip: uu,
  chipOn: mu,
  search: du,
  tbl: _u,
  row: pu,
  rowCursor: fu,
  rowPicked: bu,
  chk: hu,
  tdLeft: gu,
  tdCenter: yu,
  emptyCell: Eu,
  stop: vu,
  more: ku,
  pager: Nu,
  note: wu,
  foot: $u,
  ghost: xu,
  primary: Cu
};
function Bu(n, t = "전체") {
  if (n.length === 0) return t;
  const a = `${n[0].cd}.${n[0].nm}`;
  return n.length === 1 ? a : `${a} 외 ${n.length - 1}건`;
}
const Su = 250;
function Fd({
  value: n = "",
  onChange: t,
  items: a,
  source: o,
  multiple: l = !1,
  selected: s,
  onConfirm: r,
  trigger: c,
  emptyLabel: i = "전체",
  open: u,
  onOpenChange: m,
  placeholder: d,
  title: p = "코드도움",
  variant: f,
  disabled: b,
  className: _ = ""
}) {
  const k = o ? "source" : "static", $ = f != null ? f : k === "source" ? "modal" : "anchor", S = c != null ? c : l ? "summary" : "input", [g, N] = E(!1), y = u != null ? u : g, v = le(
    (B) => {
      u === void 0 && N(B), m && m(B);
    },
    [u, m]
  ), j = X(null), I = X(null), C = X(null), [L, F] = E(null), R = () => {
    if (!b) {
      if ($ === "anchor") {
        const B = j.current;
        if (!B) return;
        const T = B.getBoundingClientRect(), q = 320, A = T.bottom + q > window.innerHeight ? Math.max(8, T.top - q - 4) : T.bottom + 4;
        F({ left: Math.min(T.left, window.innerWidth - 320), top: A });
      }
      v(!0);
    }
  }, D = le(() => v(!1), [v]);
  return /* @__PURE__ */ e.createElement("span", { ref: j, className: [x.root, _].filter(Boolean).join(" ") }, S === "input" && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "input",
    {
      className: x.codeInput,
      value: n,
      placeholder: d,
      disabled: b,
      onChange: (B) => t && t(B.target.value.trim()),
      onKeyDown: (B) => {
        B.key === "F2" && (B.preventDefault(), R());
      },
      title: "F2: 코드도움"
    }
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: x.pickBtn,
      "aria-label": "코드도움 열기",
      disabled: b,
      onClick: R,
      tabIndex: -1
    },
    "⌕"
  )), S === "summary" && /* @__PURE__ */ e.createElement("button", { type: "button", className: x.summaryBtn, disabled: b, onClick: R }, /* @__PURE__ */ e.createElement("span", null, Bu(s != null ? s : [], i)), /* @__PURE__ */ e.createElement("i", { "aria-hidden": "true" }, "⌕")), y && k === "static" && $ === "anchor" && L && /* @__PURE__ */ e.createElement(
    Lu,
    {
      items: a != null ? a : [],
      value: n,
      title: p,
      popupRef: I,
      anchorRef: j,
      pos: L,
      onPick: (B) => {
        t && t(B.code, B), D();
      },
      onClose: D
    }
  ), y && (k === "source" || $ === "modal") && /* @__PURE__ */ e.createElement(
    Fu,
    {
      source: o,
      items: a,
      title: p,
      multiple: l,
      selected: s,
      searchRef: C,
      onConfirm: (B) => {
        r ? r(B) : B[0] && t && t(B[0].cd, { code: B[0].cd, name: B[0].nm }), D();
      },
      onClose: D
    }
  ));
}
function Lu({
  items: n,
  value: t,
  title: a,
  popupRef: o,
  anchorRef: l,
  pos: s,
  onPick: r,
  onClose: c
}) {
  const [i, u] = E(""), m = ge(() => {
    const d = i.trim().toLowerCase();
    return d ? n.filter(
      (p) => {
        var f;
        return p.code.toLowerCase().includes(d) || p.name.toLowerCase().includes(d) || ((f = p.sub) != null ? f : "").toLowerCase().includes(d);
      }
    ) : n;
  }, [n, i]);
  return Z(() => {
    const d = (f) => {
      const b = f.target;
      o.current && !o.current.contains(b) && l.current && !l.current.contains(b) && c();
    }, p = (f) => {
      f.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", p), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", p);
    };
  }, [o, l, c]), /* @__PURE__ */ e.createElement(Wt, null, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: o,
      className: x.popup,
      style: { left: s.left, top: s.top },
      role: "dialog",
      "aria-label": "코드도움"
    },
    /* @__PURE__ */ e.createElement("header", { className: x.popupHead }, /* @__PURE__ */ e.createElement("strong", null, a), /* @__PURE__ */ e.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ e.createElement("div", { className: x.searchRow }, /* @__PURE__ */ e.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        placeholder: "코드·명칭 검색",
        onChange: (d) => u(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && m.length && r(m[0]), d.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ e.createElement("ul", { className: x.list }, m.map((d) => /* @__PURE__ */ e.createElement("li", { key: d.code }, /* @__PURE__ */ e.createElement("button", { type: "button", onClick: () => r(d), className: d.code === t ? x.current : "" }, /* @__PURE__ */ e.createElement("code", null, d.code), /* @__PURE__ */ e.createElement("span", null, d.name), d.sub && /* @__PURE__ */ e.createElement("small", null, d.sub)))), m.length === 0 && /* @__PURE__ */ e.createElement("li", { className: x.empty }, "검색 결과가 없습니다"))
  ));
}
function ju(n, t) {
  const a = n.map((o) => ({ cd: o.code, nm: o.name, sub: o.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드도움",
    nameLabel: "명칭",
    fetch: ({ q: o }) => {
      const l = o.trim().toLowerCase();
      return l ? Promise.resolve({
        rows: a.filter(
          (s) => {
            var r;
            return s.cd.toLowerCase().includes(l) || s.nm.toLowerCase().includes(l) || String((r = s.sub) != null ? r : "").toLowerCase().includes(l);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function Fu({
  source: n,
  items: t,
  title: a,
  multiple: o,
  selected: l,
  searchRef: s,
  onConfirm: r,
  onClose: c
}) {
  const i = ge(() => ju(t != null ? t : [], a), [t, a]), u = n != null ? n : i, [m, d] = E(""), [p, f] = E(null), [b, _] = E(0), [k, $] = E([]), [S, g] = E(!1), [N, y] = E(!1), [v, j] = E(null), [I, C] = E(0), [L, F] = E(/* @__PURE__ */ new Map()), R = X(u);
  R.current = u, Z(() => {
    d(""), f(null), _(0), C(0), j(null), F(new Map((l != null ? l : []).map((P) => [P.cd, P])));
    const h = window.setTimeout(() => {
      s.current && s.current.focus();
    }, 30);
    return () => window.clearTimeout(h);
  }, [u.key]), Z(() => {
    let h = !0;
    const P = () => {
      y(!0), R.current.fetch({ q: m.trim(), ty: p, page: b }).then((fe) => {
        var _t;
        h && ($((_t = fe.rows) != null ? _t : []), g(!!fe.hasMore), j(null), C(0));
      }).catch((fe) => {
        h && ($([]), g(!1), j(fe instanceof Error ? fe.message : "코드도움 조회에 실패했습니다"));
      }).finally(() => {
        h && y(!1);
      });
    }, M = window.setTimeout(P, m.trim() ? Su : 0);
    return () => {
      h = !1, window.clearTimeout(M);
    };
  }, [u.key, m, p, b]);
  const D = ge(() => {
    var P;
    const h = [
      { key: "cd", label: "Code", width: "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (M) => /* @__PURE__ */ e.createElement(e.Fragment, null, M.nm, M.useYn === !1 && /* @__PURE__ */ e.createElement("span", { className: x.stop }, "중단"))
      }
    ];
    return u.typeLabel && h.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (M) => u.typeLabel ? u.typeLabel(M) : ""
    }), h.concat((P = u.extraColumns) != null ? P : []);
  }, [u]), B = le((h) => {
    F((P) => {
      const M = new Map(P);
      return M.has(h.cd) ? M.delete(h.cd) : M.set(h.cd, h), M;
    });
  }, []), T = le((h) => r([h]), [r]), q = le(() => r(Array.from(L.values())), [L, r]), A = k.length > 0 && k.every((h) => L.has(h.cd)), en = () => {
    F((h) => {
      const P = new Map(h);
      return A ? k.forEach((M) => P.delete(M.cd)) : k.forEach((M) => P.set(M.cd, M)), P;
    });
  }, tn = (h) => {
    if (h.key === "Escape") {
      h.stopPropagation(), c();
      return;
    }
    if (h.key === "ArrowDown" || h.key === "ArrowUp") {
      h.preventDefault(), C((P) => Math.max(0, Math.min(k.length - 1, P + (h.key === "ArrowDown" ? 1 : -1))));
      return;
    }
    if (h.key === " " && o && k[I]) {
      h.preventDefault(), B(k[I]);
      return;
    }
    h.key === "Enter" && (h.preventDefault(), o ? q() : k[I] && T(k[I]));
  };
  return /* @__PURE__ */ e.createElement(Wt, null, /* @__PURE__ */ e.createElement("div", { className: x.ov, onClick: c }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: x.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      onClick: (h) => h.stopPropagation(),
      onKeyDown: tn
    },
    /* @__PURE__ */ e.createElement("div", { className: x.head }, /* @__PURE__ */ e.createElement("h2", null, u.title), o && /* @__PURE__ */ e.createElement("span", { className: x.sub }, "복수 선택 가능"), /* @__PURE__ */ e.createElement("button", { type: "button", className: x.x, onClick: c, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ e.createElement("div", { className: x.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ e.createElement("div", { className: x.chips }, /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: p === null ? `${x.chip} ${x.chipOn}` : x.chip,
        onClick: () => {
          f(null), _(0);
        }
      },
      "전체"
    ), u.filters.map((h) => /* @__PURE__ */ e.createElement(
      "button",
      {
        key: h.value,
        type: "button",
        className: p === h.value ? `${x.chip} ${x.chipOn}` : x.chip,
        onClick: () => {
          f(h.value), _(0);
        }
      },
      h.label
    ))), /* @__PURE__ */ e.createElement(
      "input",
      {
        ref: s,
        className: x.search,
        value: m,
        placeholder: "코드, 명칭 검색",
        onChange: (h) => {
          d(h.target.value), _(0);
        }
      }
    ), /* @__PURE__ */ e.createElement("div", { className: x.tbl }, /* @__PURE__ */ e.createElement("table", null, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, o && /* @__PURE__ */ e.createElement("th", { className: x.chk }, /* @__PURE__ */ e.createElement(
      "input",
      {
        type: "checkbox",
        checked: A,
        onChange: en,
        "aria-label": "표시된 행 전체 선택"
      }
    )), D.map((h) => /* @__PURE__ */ e.createElement("th", { key: h.key, style: h.width ? { width: h.width } : void 0 }, h.label)))), /* @__PURE__ */ e.createElement("tbody", null, k.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: x.emptyCell, colSpan: D.length + (o ? 1 : 0) }, N ? "조회 중…" : v || u.emptyText || "검색 결과가 없습니다")) : k.map((h, P) => /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: h.cd,
        className: [
          x.row,
          P === I ? x.rowCursor : "",
          L.has(h.cd) ? x.rowPicked : ""
        ].filter(Boolean).join(" "),
        onClick: () => {
          C(P), o ? B(h) : T(h);
        }
      },
      o && /* @__PURE__ */ e.createElement("td", { className: x.chk }, /* @__PURE__ */ e.createElement(
        "input",
        {
          type: "checkbox",
          checked: L.has(h.cd),
          onChange: () => B(h),
          onClick: (M) => M.stopPropagation(),
          "aria-label": `${h.cd} 선택`
        }
      )),
      D.map((M) => {
        var fe;
        return /* @__PURE__ */ e.createElement("td", { key: M.key, className: M.align === "left" ? x.tdLeft : x.tdCenter }, M.render ? M.render(h) : String((fe = h[M.key]) != null ? fe : ""));
      })
    ))))), (S || b > 0) && /* @__PURE__ */ e.createElement("div", { className: x.more }, /* @__PURE__ */ e.createElement("span", null, S ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ e.createElement("span", { className: x.pager }, /* @__PURE__ */ e.createElement("button", { type: "button", disabled: b === 0, onClick: () => _((h) => Math.max(0, h - 1)) }, "이전"), /* @__PURE__ */ e.createElement("b", null, b + 1), S && /* @__PURE__ */ e.createElement("button", { type: "button", onClick: () => _((h) => h + 1) }, "다음"))), o && /* @__PURE__ */ e.createElement("p", { className: x.note }, "선택 ", /* @__PURE__ */ e.createElement("b", null, L.size), "건 — 선택이 없으면 ", /* @__PURE__ */ e.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ e.createElement("div", { className: x.foot }, o && /* @__PURE__ */ e.createElement("button", { type: "button", className: x.ghost, onClick: () => F(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ e.createElement("button", { type: "button", className: x.ghost, onClick: c }, "취소"), o && /* @__PURE__ */ e.createElement("button", { type: "button", className: x.primary, onClick: q }, "확인"))
  )));
}
const Mu = "_input_1sybn_1", Au = {
  input: Mu
};
function Md({
  value: n,
  onChange: t,
  mode: a = "date",
  min: o,
  max: l,
  disabled: s,
  "aria-label": r,
  className: c = ""
}) {
  return /* @__PURE__ */ e.createElement(
    "input",
    {
      type: a,
      className: [Au.input, c].filter(Boolean).join(" "),
      value: n,
      min: o,
      max: l,
      disabled: s,
      "aria-label": r,
      onChange: (i) => t(i.target.value)
    }
  );
}
function Iu(n) {
  return n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function Du(n) {
  return n.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function qt(n, t = !0) {
  n = Du(n);
  const a = t && /^\s*-/.test(n), o = n.split(".", 1)[0].replace(/[^\d]/g, "");
  return o ? (a ? "-" : "") + o.replace(/^0+(?=\d)/, "") : a ? "-" : "";
}
function Ru(n) {
  var o;
  if (n == null || n === "") return "";
  const t = typeof n == "number" ? String(n) : n.trim(), a = /^(-?)(\d+)(\.\d+)?$/.exec(t);
  return a ? a[1] + Iu(a[2]) + ((o = a[3]) != null ? o : "") : t;
}
function Tu(n) {
  const t = qt(n);
  if (t === "" || t === "-") return;
  const a = Number(t);
  return Number.isFinite(a) ? a : void 0;
}
function zu(n) {
  const t = n.match(/\d/g);
  return t ? t.length : 0;
}
function Ad({
  value: n,
  onChangeAm: t,
  allowNegative: a = !0,
  className: o,
  ...l
}) {
  const s = X(null), r = X(null);
  return At(() => {
    const c = s.current, i = r.current;
    if (r.current = null, !c || i === null) return;
    let u = 0, m = 0;
    for (; u < c.value.length && m < i; )
      /\d/.test(c.value[u]) && (m += 1), u += 1;
    c.setSelectionRange(u, u);
  }), /* @__PURE__ */ e.createElement(
    "input",
    {
      ...l,
      ref: s,
      type: "text",
      inputMode: "numeric",
      className: o,
      value: Ru(n),
      onChange: (c) => {
        var m;
        const i = c.target;
        r.current = zu(i.value.slice(0, (m = i.selectionStart) != null ? m : i.value.length));
        const u = qt(i.value, a);
        t({ text: u, num: Tu(u) });
      }
    }
  );
}
const Ct = 30, Pu = BigInt(10);
function Se(n) {
  let t = BigInt(1);
  for (let a = 0; a < n; a += 1) t = t * Pu;
  return t;
}
function _e(n, t = 0) {
  return { u: n, s: t };
}
const Gt = _e(BigInt(0));
function Kt(n, t) {
  if (n.s === t.s) return [n.u, t.u, n.s];
  const a = Math.max(n.s, t.s);
  return [n.u * Se(a - n.s), t.u * Se(a - t.s), a];
}
function Xe(n, t) {
  const [a, o, l] = Kt(n, t);
  return _e(a + o, l);
}
function it(n, t) {
  const [a, o, l] = Kt(n, t);
  return _e(a - o, l);
}
function se(n, t) {
  return _e(n.u * t.u, n.s + t.s);
}
function ke(n, t) {
  if (t.u === BigInt(0)) return null;
  const a = n.u * Se(t.s + Ct), o = t.u * Se(n.s);
  return _e(a / o, Ct);
}
function Ht(n) {
  return _e(-n.u, n.s);
}
function pe(n, t, a) {
  if (t >= n.s)
    return _e(n.u * Se(t - n.s), t);
  const o = Se(n.s - t), l = n.u < BigInt(0), s = l ? -n.u : n.u, r = s / o, c = s % o;
  let i;
  return c === BigInt(0) || a === "down" ? i = r : a === "up" ? i = r + BigInt(1) : i = c * BigInt(2) >= o ? r + BigInt(1) : r, _e(l ? -i : i, t);
}
function z(n) {
  const t = n.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), o = t.replace(/^[+-]/, ""), l = o.indexOf("."), s = l < 0 ? o : o.slice(0, l) + o.slice(l + 1), r = l < 0 ? 0 : o.length - l - 1, c = BigInt(s === "" ? "0" : s);
  return _e(a ? -c : c, r);
}
function ut(n) {
  var a;
  const t = z(String(n));
  return t || ((a = z(n.toFixed(20))) != null ? a : Gt);
}
function te(n, t = n.s, a = !1) {
  const o = pe(n, Math.max(t, 0), "half"), l = o.u < BigInt(0), s = (l ? -o.u : o.u).toString().padStart(t + 1, "0"), r = s.length - t;
  let c = s.slice(0, r);
  const i = s.slice(r);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (l ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function ot(n) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(n.trim());
  if (!t) return null;
  const a = Number(t[1]), o = Number(t[2]), l = Number(t[3]);
  return o < 1 || o > 12 || l < 1 || l > mt(a, o) ? null : { y: a, m: o, d: l };
}
function Ou(n) {
  return n % 4 === 0 && n % 100 !== 0 || n % 400 === 0;
}
function mt(n, t) {
  return t === 2 ? Ou(n) ? 29 : 28 : [4, 6, 9, 11].includes(t) ? 30 : 31;
}
function Be({ y: n, m: t, d: a }) {
  const o = Math.floor((14 - t) / 12), l = n + 4800 - o, s = t + 12 * o - 3;
  return a + Math.floor((153 * s + 2) / 5) + 365 * l + Math.floor(l / 4) - Math.floor(l / 100) + Math.floor(l / 400) - 32045;
}
function Ut(n, t) {
  const a = Be(n) + t + 32044, o = Math.floor((4 * a + 3) / 146097), l = a - Math.floor(146097 * o / 4), s = Math.floor((4 * l + 3) / 1461), r = l - Math.floor(1461 * s / 4), c = Math.floor((5 * r + 2) / 153);
  return {
    d: r - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * o + s - 4800 + Math.floor(c / 10)
  };
}
function Yt(n, t, a = "exclude-first") {
  const o = Be(n) > Be(t), l = o ? t : n, s = o ? n : t, r = a === "include-first", c = Be(s) - Be(l) + (r ? 1 : 0), i = r ? Ut(s, 1) : s;
  let u = i.y - l.y, m = i.m - l.m, d = i.d - l.d;
  if (d < 0) {
    m -= 1;
    const p = i.m === 1 ? 12 : i.m - 1, f = i.m === 1 ? i.y - 1 : i.y;
    d += mt(f, p);
  }
  return m < 0 && (u -= 1, m += 12), { days: c, y: u, m, d, swapped: o };
}
function Ve(n, t) {
  return Ut(n, t);
}
function Bt(n, t) {
  const a = n.y * 12 + (n.m - 1) + t, o = Math.floor(a / 12), l = a % 12 + 1;
  return { y: o, m: l, d: Math.min(n.d, mt(o, l)) };
}
const Xu = ["월", "화", "수", "목", "금", "토", "일"];
function lt(n) {
  return Xu[Be(n) % 7];
}
function J(n) {
  return `${n.y}-${String(n.m).padStart(2, "0")}-${String(n.d).padStart(2, "0")}`;
}
const Re = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], et = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function St(n) {
  var t;
  return (t = et[n]) != null ? t : n in et ? et[n] : null;
}
function st(n, t) {
  return n.find((a) => a.code === t);
}
function Vt(n) {
  return n.code === "KRW" ? "KRW 기준" : `${n.code} ${n.per} = ${n.krw}원`;
}
function Jt(n, t, a, o) {
  const l = st(n, a), s = st(n, o);
  if (!l || !s) return null;
  const r = z(l.krw), c = z(s.krw), i = z(String(l.per)), u = z(String(s.per));
  if (!r || !c || !i || !u) return null;
  const m = ke(se(t, r), i);
  if (!m) return null;
  const d = ke(se(m, u), c);
  return d ? {
    value: pe(d, 2, "half"),
    notice: `${Vt(l)} · 샘플 고시(원천 미결)`
  } : null;
}
function Wu(n, t) {
  let a = null;
  for (const l of n)
    if (l.value) {
      if (a === null) {
        a = l.sign === "-" ? Ht(l.value) : l.value;
        continue;
      }
      switch (l.sign) {
        case "+":
          a = Xe(a, l.value);
          break;
        case "-":
          a = it(a, l.value);
          break;
        case "*":
          a = se(a, l.value);
          break;
        default: {
          const s = ke(a, l.value);
          if (!s) return { ok: !1, error: "divide-by-zero" };
          a = s;
          break;
        }
      }
    }
  const o = a != null ? a : Gt;
  return { ok: !0, value: t ? pe(o, t.digits, t.mode) : o };
}
const Lt = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function Pe() {
  return { sign: "+", text: "" };
}
function qu(n) {
  const t = n.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), o = t.replace(/-/g, ""), l = o.indexOf("."), s = l < 0 ? o : o.slice(0, l), r = l < 0 ? "" : "." + o.slice(l + 1).replace(/\./g, "");
  return (a ? "-" : "") + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + r;
}
function Gu(n) {
  return n.map((t) => ({ sign: t.sign, value: z(t.text) }));
}
function Ku(n) {
  const { lines: t, onLines: a, active: o, onActive: l, digits: s, onDigits: r, mode: c, onMode: i } = n, u = X([]), m = Math.min(o, t.length - 1);
  Z(() => {
    var g;
    (g = u.current[m]) == null || g.focus();
  }, [m, t.length]);
  const d = Wu(Gu(t), { digits: s, mode: c }), p = d.ok ? te(d.value, s, !0) : "0으로 나눌 수 없음", f = (g, N) => {
    a(t.map((y, v) => v === g ? { ...y, ...N } : y));
  }, b = (g = t.length, N = "") => {
    const y = [...t];
    y.splice(g, 0, { ...Pe(), text: N }), a(y), l(g);
  }, _ = (g) => {
    if (t.length === 1) {
      a([Pe()]);
      return;
    }
    a(t.filter((N, y) => y !== g)), l(Math.max(0, g - 1));
  }, k = () => {
    d.ok && b(t.length, te(d.value, s, !0));
  }, $ = (g, N) => {
    const y = g.key, v = Hu(y);
    if (v && !(y === "-" && t[N].text === "")) {
      g.preventDefault(), f(N, { sign: v });
      return;
    }
    if (y === "v" || y === "V") {
      g.preventDefault(), k();
      return;
    }
    y === "Enter" ? (g.preventDefault(), N === t.length - 1 ? b() : l(N + 1)) : y === "ArrowDown" ? (g.preventDefault(), l(Math.min(N + 1, t.length - 1))) : y === "ArrowUp" ? (g.preventDefault(), l(Math.max(N - 1, 0))) : y === "Insert" ? (g.preventDefault(), b(N + 1)) : y === "Delete" && t[N].text === "" ? (g.preventDefault(), _(N)) : y === "F4" && (g.preventDefault(), S());
  }, S = () => {
    a([Pe()]), l(0);
  };
  return /* @__PURE__ */ e.createElement("div", { className: "bical-general" }, /* @__PURE__ */ e.createElement("div", { className: "bical-side" }, /* @__PURE__ */ e.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-key", onClick: () => b(m + 1) }, "라인추가 (Ins)"), /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-key", onClick: () => _(m) }, "라인삭제 (Del)"), /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-key", onClick: k }, "현재금액추가 (V)"), /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-key", onClick: S }, "초기화 (F4)")), /* @__PURE__ */ e.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ e.createElement("div", { className: "bical-keys" }, Lt.map((g) => {
    var N;
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: g.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((N = t[m]) == null ? void 0 : N.sign) === g.key,
        onClick: () => f(m, { sign: g.key })
      },
      g.label,
      " (",
      g.hot,
      ")"
    );
  })), /* @__PURE__ */ e.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: s, onChange: (g) => r(Number(g.target.value)) }, [0, 1, 2, 3, 4].map((g) => /* @__PURE__ */ e.createElement("option", { key: g, value: g }, g))), /* @__PURE__ */ e.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: c, onChange: (g) => i(g.target.value) }, /* @__PURE__ */ e.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ e.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ e.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ e.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ e.createElement("div", { className: "bical-grid" }, t.map((g, N) => {
    var y;
    return /* @__PURE__ */ e.createElement("div", { key: N, className: `bical-line${N === m ? " bical-line--active" : ""}` }, /* @__PURE__ */ e.createElement("span", { className: "bical-caret" }, N === m ? "❯" : ""), /* @__PURE__ */ e.createElement("span", { className: "bical-sign" }, (y = Lt.find((v) => v.key === g.sign)) == null ? void 0 : y.label), /* @__PURE__ */ e.createElement(
      "input",
      {
        ref: (v) => {
          u.current[N] = v;
        },
        value: g.text,
        inputMode: "decimal",
        "aria-label": `${N + 1}번째 금액`,
        onFocus: () => l(N),
        onChange: (v) => f(N, { text: qu(v.target.value) }),
        onKeyDown: (v) => $(v, N)
      }
    ));
  })), /* @__PURE__ */ e.createElement("div", { className: `bical-result${d.ok ? "" : " bical-error"}` }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ e.createElement("div", { className: "bical-value" }, p))));
}
function Hu(n) {
  const t = n.toLowerCase();
  return t === "a" || n === "+" ? "+" : t === "s" || n === "-" ? "-" : t === "d" || n === "*" ? "*" : t === "f" || n === "/" ? "/" : null;
}
function Uu(n) {
  const t = [];
  let a = 0;
  for (; a < n.length; ) {
    const o = n[a];
    if (o === " " || o === "	" || o === `
`)
      a += 1;
    else if (o >= "0" && o <= "9" || o === "." || o === ",") {
      let l = a;
      for (; l < n.length && (n[l] >= "0" && n[l] <= "9" || n[l] === "." || n[l] === ","); ) l += 1;
      const s = z(n.slice(a, l));
      if (!s) return null;
      t.push({ t: "num", v: s }), a = l;
    } else if (o === "+" || o === "-" || o === "*" || o === "/")
      t.push({ t: "op", v: o }), a += 1;
    else if (o === "(")
      t.push({ t: "(" }), a += 1;
    else if (o === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class Yu {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const o = this.term();
      if (!o.ok) return o;
      t = { ok: !0, value: a.v === "+" ? Xe(t.value, o.value) : it(t.value, o.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const o = this.unary();
      if (!o.ok) return o;
      if (a.v === "*")
        t = { ok: !0, value: se(t.value, o.value) };
      else {
        const l = ke(t.value, o.value);
        if (!l) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: l };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? Ht(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const o = this.peek();
      return !o || o.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function Vu(n) {
  const t = Uu(n);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new Yu(t).parse();
}
const Oe = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (샘플 고시)"
], Ju = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function Zu(n, t) {
  return n.replace(/오늘/g, J(t)).replace(/내일/g, J(Ve(t, 1))).replace(/어제/g, J(Ve(t, -1)));
}
function Qu(n) {
  const t = [];
  for (const a of n.matchAll(Ju)) {
    const o = ot(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    o && t.push(o);
  }
  return t;
}
const em = /부터|까지|에서|일수|며칠|기간|차이|~/;
function tm(n, t) {
  if (t.length < 2 || !em.test(n)) return null;
  const a = /초일\s*산입|양편넣기/.test(n), o = Yt(t[0], t[1], a ? "include-first" : "exclude-first"), l = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${J(t[0])} ~ ${J(t[1])} 기간(${l})` + (o.swapped ? " · 역순 입력" : ""),
    value: `${o.days}일 (${o.y}년 ${o.m}개월 ${o.d}일)`
  };
}
const nm = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function am(n, t) {
  if (t.length !== 1) return null;
  const a = nm.exec(n);
  if (!a) return null;
  const o = Number(a[1]), l = a[3] === "전" || a[3] === "이전", s = l ? -o : o, r = t[0];
  let c;
  return a[2] === "일" ? c = Ve(r, s) : a[2] === "주" ? c = Ve(r, s * 7) : a[2] === "년" ? c = Bt(r, s * 12) : c = Bt(r, s), {
    ok: !0,
    explain: `${J(r)} 에서 ${o}${a[2]} ${l ? "전" : "후"}`,
    value: `${J(c)} (${lt(c)})`
  };
}
function om(n, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(n);
  if (!a) return null;
  const o = a[2] ? Zt(a[2]) : null, l = z(a[1]);
  if (!l) return null;
  const s = o ? se(l, o) : l, r = St(a[3]);
  if (!r) return null;
  const i = r !== "KRW" ? "KRW" : St(lm(n));
  if (!i || i === r) return null;
  const u = Jt(t, s, r, i);
  return u ? {
    ok: !0,
    explain: `${te(s, s.s, !0)} ${r} → ${i} · ${u.notice}`,
    value: `${te(u.value, 2, !0)} ${i}`
  } : null;
}
function lm(n) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(n);
  return t ? t[1] : "원";
}
const sm = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function Zt(n) {
  var t;
  return (t = z(sm[n])) != null ? t : ut(1);
}
const rm = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, cm = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function im(n) {
  return n.replace(rm, (t) => {
    let a = z("0"), o = !1;
    for (const l of t.matchAll(cm)) {
      const s = z(l[1]);
      s && (o = !0, a = Xe(a, l[2] ? se(s, Zt(l[2])) : s));
    }
    return o ? te(a, a.s) : t;
  });
}
const um = /원화|원|엔|씩|개월|개|명|건/g;
function mm(n) {
  return im(n).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(um, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const dm = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function _m(n, t, a) {
  const o = z("1"), l = te(se(t, ut(100)), 0);
  if (a === "add")
    return {
      value: pe(se(n, Xe(o, t)), 0, "half"),
      explain: `消費税 ${l}% 가산(税抜 기준)`
    };
  const s = ke(se(n, t), Xe(o, t));
  return {
    value: s ? pe(s, 0, "down") : n,
    explain: `消費税 ${l}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function pm(n, t) {
  var i;
  const a = n.trim();
  if (!a) return { ok: !1, supported: Oe };
  const o = Zu(a, t.today), l = Qu(o), s = tm(o, l);
  if (s) return s;
  const r = am(o, l);
  if (r) return r;
  const c = om(o, (i = t.rates) != null ? i : []);
  return c || fm(o, t);
}
function fm(n, t) {
  var u, m;
  const a = dm.exec(n), o = a ? n.slice(0, a.index) : n, l = mm(o);
  if (!l) return { ok: !1, supported: Oe };
  const s = Vu(l);
  if (!s.ok)
    return { ok: !1, supported: Oe };
  if (!a)
    return { ok: !0, explain: l, value: jt(s.value), expr: l };
  const r = (m = (u = bm(a[2])) != null ? u : t.taxRate) != null ? m : null;
  if (!r)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세율(a_fa_param)을 읽어 오면 계산합니다", ...Oe]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = _m(s.value, r, c);
  return {
    ok: !0,
    explain: `${l} · ${i.explain}`,
    value: jt(i.value),
    expr: l
  };
}
function bm(n) {
  var a;
  if (!n) return null;
  const t = z(n);
  return t && (a = ke(t, ut(100))) != null ? a : null;
}
function jt(n) {
  const t = pe(n, 2, "half"), a = pe(t, 0, "down");
  return it(t, a).u === BigInt(0) ? te(t, 0, !0) : te(t, 2, !0);
}
const ee = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function Ft(n, t) {
  const a = ee[n].units.find((l) => l.key === t);
  if (!a) return null;
  const o = z(a.factor);
  if (!o) throw new Error(`단위 환산표가 깨졌습니다 — ${a.key}`);
  return o;
}
function hm(n, t, a, o, l = 4, s = "half") {
  const r = Ft(n, t), c = Ft(n, a);
  if (!r || !c) return null;
  const i = ke(se(o, r), c);
  return i ? pe(i, l, s) : null;
}
const gm = [0, 1, 2, 3, 4, 6], ym = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function Em(n) {
  const { tab: t, onTab: a, seed: o, onClose: l, history: s, onHistory: r } = n, [c, i] = E(() => o == null ? [Pe()] : [{ sign: "+", text: te(Cm(o), 0, !0) }]), [u, m] = E(0), [d, p] = E(0), [f, b] = E("half"), _ = X(null);
  Z(() => {
    const $ = (S) => {
      S.key === "Escape" && (S.preventDefault(), l());
    };
    return document.addEventListener("keydown", $), () => document.removeEventListener("keydown", $);
  }, [l]), Z(() => {
    var $, S;
    (S = ($ = _.current) == null ? void 0 : $.querySelector("[data-autofocus]")) == null || S.focus();
  }, [t]);
  const k = ($) => {
    const S = [...c.filter((g) => g.text !== ""), { sign: "+", text: $ }, Pe()];
    i(S), m(S.length - 1), a("general");
  };
  return /* @__PURE__ */ e.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ e.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: _ }, /* @__PURE__ */ e.createElement("div", { className: "bical-head" }, /* @__PURE__ */ e.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ e.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: l }, "✕")), /* @__PURE__ */ e.createElement("div", { className: "bical-tabs", role: "tablist" }, ym.map(($) => /* @__PURE__ */ e.createElement(
    "button",
    {
      key: $.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": $.key === t,
      onClick: () => a($.key)
    },
    $.label
  ))), /* @__PURE__ */ e.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ e.createElement(Nm, { history: s, onHistory: r, onPush: k }), t === "general" && /* @__PURE__ */ e.createElement(
    Ku,
    {
      lines: c,
      onLines: i,
      active: u,
      onActive: m,
      digits: d,
      onDigits: p,
      mode: f,
      onMode: b
    }
  ), t === "date" && /* @__PURE__ */ e.createElement(wm, null), t === "unit" && /* @__PURE__ */ e.createElement($m, null), t === "fx" && /* @__PURE__ */ e.createElement(xm, null)), /* @__PURE__ */ e.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-btn", onClick: l }, "닫기"))));
}
const vm = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], km = 20;
function Nm({ history: n, onHistory: t, onPush: a }) {
  var b;
  const [o, l] = E(""), [s, r] = E(null), [c, i] = E(!1), [u, m] = E(!1), d = X(!1), p = ge(dt, []), f = (_) => {
    l(_), m(!1);
    const k = pm(_, { today: p, rates: Re, taxRate: null });
    r(k), _.trim() && t([_, ...n.filter(($) => $ !== _)].slice(0, km));
  };
  return /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "data-autofocus": !0,
      value: o,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (_) => l(_.target.value),
      onCompositionStart: () => {
        d.current = !0;
      },
      onCompositionEnd: () => {
        d.current = !1;
      },
      onKeyDown: (_) => {
        _.key === "Enter" && !_.shiftKey && !d.current && !_.nativeEvent.isComposing && (_.preventDefault(), f(o));
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: "bical-chips" }, vm.map((_) => /* @__PURE__ */ e.createElement("button", { key: _, type: "button", className: "bical-chip", onClick: () => f(_) }, _))), s && (s.ok ? /* @__PURE__ */ e.createElement("div", { className: "bical-result" }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, s.explain), /* @__PURE__ */ e.createElement("div", { className: "bical-value" }, s.value), /* @__PURE__ */ e.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var _;
        (_ = navigator.clipboard) == null || _.writeText(s.value).then(
          () => m(!0),
          () => m(!1)
        );
      }
    },
    u ? "복사함" : "결과복사"
  ), /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(s.value) }, "일반계산에 추가"))) : /* @__PURE__ */ e.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ e.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((b = s.supported) != null ? b : Oe).map((_) => /* @__PURE__ */ e.createElement("li", { key: _ }, _))))), n.length > 0 && /* @__PURE__ */ e.createElement("div", { className: "bical-log" }, /* @__PURE__ */ e.createElement("button", { type: "button", onClick: () => i((_) => !_) }, "기록 ", n.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ e.createElement("ol", null, n.map((_) => /* @__PURE__ */ e.createElement("li", { key: _ }, /* @__PURE__ */ e.createElement("button", { type: "button", onClick: () => f(_) }, _))))), /* @__PURE__ */ e.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function wm() {
  const n = ge(dt, []), [t, a] = E(J(n)), [o, l] = E(J(n)), [s, r] = E("exclude-first"), c = ot(t), i = ot(o), u = c && i ? Yt(c, i, s) : null;
  return /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: s, onChange: (m) => r(m.target.value) }, /* @__PURE__ */ e.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ e.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ e.createElement("input", { className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (m) => a(m.target.value) }), /* @__PURE__ */ e.createElement("span", null, "~"), /* @__PURE__ */ e.createElement("input", { className: "bical-input", type: "date", value: o, onChange: (m) => l(m.target.value) })), u ? /* @__PURE__ */ e.createElement("div", { className: "bical-result" }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, J(c), "(", lt(c), ") ~ ", J(i), "(", lt(i), ")", u.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ e.createElement("div", { className: "bical-value" }, u.days.toLocaleString(), "일"), /* @__PURE__ */ e.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", u.y, "년 ", u.m, "개월 ", u.d, "일")) : /* @__PURE__ */ e.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function $m() {
  const [n, t] = E("area"), [a, o] = E(ee.area.units[0].key), [l, s] = E(ee.area.units[4].key), [r, c] = E(""), [i, u] = E(4), [m, d] = E("half"), p = (_) => {
    t(_), o(ee[_].units[0].key), s(ee[_].units[1].key), c("");
  }, f = z(r), b = f ? hm(n, a, l, f, i, m) : null;
  return /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: n, onChange: (_) => p(_.target.value) }, Object.keys(ee).map((_) => /* @__PURE__ */ e.createElement("option", { key: _, value: _ }, ee[_].label))), /* @__PURE__ */ e.createElement("span", { className: "bical-sub" }, "기준 ", ee[n].base)), /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ e.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: r,
      onChange: (_) => c(_.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: a, onChange: (_) => o(_.target.value) }, ee[n].units.map((_) => /* @__PURE__ */ e.createElement("option", { key: _.key, value: _.key }, _.label))), /* @__PURE__ */ e.createElement("span", null, "→"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: l, onChange: (_) => s(_.target.value) }, ee[n].units.map((_) => /* @__PURE__ */ e.createElement("option", { key: _.key, value: _.key }, _.label)))), /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: i, onChange: (_) => u(Number(_.target.value)) }, gm.map((_) => /* @__PURE__ */ e.createElement("option", { key: _, value: _ }, _))), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: m, onChange: (_) => d(_.target.value) }, /* @__PURE__ */ e.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ e.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ e.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ e.createElement("div", { className: "bical-result" }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, Mt(n, a), " → ", Mt(n, l), " · 기준단위 1단계 환산"), /* @__PURE__ */ e.createElement("div", { className: "bical-value" }, b ? te(b, i, !0) : "—")));
}
function Mt(n, t) {
  var a, o;
  return (o = (a = ee[n].units.find((l) => l.key === t)) == null ? void 0 : a.label) != null ? o : t;
}
function xm() {
  const n = ge(dt, []), [t, a] = E(J(n)), [o, l] = E("JPY"), [s, r] = E("KRW"), [c, i] = E(""), u = z(c), m = u ? Jt(Re, u, o, s) : null, d = st(Re, o);
  return /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ e.createElement("input", { className: "bical-input", type: "date", value: t, onChange: (p) => a(p.target.value) })), /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ e.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (p) => i(p.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: o, onChange: (p) => l(p.target.value) }, Re.map((p) => /* @__PURE__ */ e.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")"))), /* @__PURE__ */ e.createElement("span", null, "→"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: s, onChange: (p) => r(p.target.value) }, Re.map((p) => /* @__PURE__ */ e.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")")))), /* @__PURE__ */ e.createElement("div", { className: "bical-result" }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, d ? Vt(d) : ""), /* @__PURE__ */ e.createElement("div", { className: "bical-value" }, m ? te(m.value, 2, !0) : "—")), /* @__PURE__ */ e.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ e.createElement("b", null, "샘플 고시입니다 — 원천 미결."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function dt() {
  const n = /* @__PURE__ */ new Date();
  return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate() };
}
function Cm(n) {
  var t;
  return pe((t = z(String(n))) != null ? t : z("0"), 0, "half");
}
const Qt = an(null);
function Id({ children: n }) {
  const [t, a] = E(!1), [o, l] = E("text"), [s, r] = E(null), [c, i] = E([]), [u, m] = E(0), d = ge(() => ({
    open: (p) => {
      var f, b;
      l((f = p == null ? void 0 : p.tab) != null ? f : "text"), r((b = p == null ? void 0 : p.seed) != null ? b : null), m((_) => _ + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ e.createElement(Qt.Provider, { value: d }, n, t && /* @__PURE__ */ e.createElement(
    Em,
    {
      key: u,
      tab: o,
      onTab: l,
      seed: s,
      onClose: d.close,
      history: c,
      onHistory: i
    }
  ));
}
function Dd() {
  var n;
  return (n = on(Qt)) != null ? n : { open: () => {
  }, close: () => {
  } };
}
class Rd extends It {
  constructor() {
    super(...arguments), this.rootRef = ln(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new Xt(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...o } = this.props;
    return /* @__PURE__ */ e.createElement("div", { ref: this.rootRef, ...o }, a);
  }
}
export {
  id as AXActionCard,
  zm as AXAiIconBadge,
  Ym as AXAiSuggestionBanner,
  Ot as AXAvatar,
  Pm as AXAvatarStack,
  Om as AXBadge,
  ud as AXBreadcrumb,
  ad as AXButton,
  Dm as AXCardPanel,
  Xm as AXCommentRow,
  Am as AXCommentThread,
  td as AXDataTable,
  Rm as AXDivider,
  dd as AXDrawer,
  _d as AXDropdownMenu,
  Vm as AXEmptyState,
  hd as AXErpButton,
  Em as AXErpCalculatorModal,
  Id as AXErpCalculatorProvider,
  Ld as AXErpCard,
  Fd as AXErpCodePicker,
  Md as AXErpDatePicker,
  Nd as AXErpField,
  yd as AXErpGlyph,
  Cd as AXErpGrid,
  xd as AXErpHint,
  Ed as AXErpIcon,
  gd as AXErpIconButton,
  Ad as AXErpMoneyInput,
  fd as AXErpPage,
  $d as AXErpPill,
  wd as AXErpReadout,
  kd as AXErpSearchBar,
  jd as AXErpSummaryCard,
  vd as AXErpTabs,
  bd as AXErpTitleBar,
  Jm as AXExpandableSummary,
  Wm as AXFileChip,
  oo as AXFileTypeIcon,
  od as AXIconButton,
  nd as AXKeyValueGrid,
  qm as AXKeyValueRow,
  Gm as AXListRow,
  pd as AXModal,
  Tm as AXPanelHeader,
  Km as AXPersonRow,
  Zm as AXProgressBar,
  Hm as AXRankingRow,
  ld as AXSearchInput,
  sd as AXSegmentedControl,
  Um as AXStatusBadge,
  Qm as AXStepProgress,
  rd as AXTagChip,
  cd as AXToggleSwitch,
  md as AXTreeItem,
  ed as AXTypingDots,
  Dt as GW_ORIGIN,
  Wt as OBTPortal,
  Rd as OBTResizeContainer,
  Xt as OBTResizeSensor,
  We as REFRESH_KEY,
  tt as SESSION_EXPIRED_EVENT,
  rt as TOKEN_KEY,
  qt as amDigits,
  Tu as amNumber,
  qe as authorizedFetch,
  Bu as axErpCodeLabel,
  mn as clearTokens,
  Lm as colors,
  jm as configureAuth,
  Mm as configureComments,
  ct as decodeClaims,
  Ru as fmtAm,
  bn as getFreshToken,
  cn as getStoredToken,
  rn as isExpired,
  Tt as isRefreshExpired,
  hn as isReply,
  Sd as measureMoneyMetrics,
  Bd as moneyColWidth,
  Si as moneyColWidthForDigits,
  Te as notifySessionExpired,
  Fm as onSessionExpired,
  Pt as refreshTokens,
  un as saveTokens,
  _n as startRefreshExpiryWatch,
  zt as stopRefreshExpiryWatch,
  Du as toHalfWidth,
  Dd as useAXErpCalculator,
  Im as useCommentCounts,
  Nn as useComments
};
